/// <reference path="../typings/index.d.ts" />
/// <reference path="Util.d.ts" />
declare var dados: any;
declare var Switchery: any;
declare var formatOptionsSelect: any;
declare var formatRepoJogador: any;
declare var Cookies: any;
declare var webkitSpeechRecognition: any;
interface WorkerOptions {
  credentials?: RequestCredentials;
  name?: string;
}
interface SharedWorker extends EventTarget, AbstractWorker {
  /** Returns sharedWorker's MessagePort object which can be used to communicate with the global environment. */
  readonly port: MessagePort;
  addEventListener<K extends keyof AbstractWorkerEventMap>(type: K, listener: (this: SharedWorker, ev: AbstractWorkerEventMap[K]) => any, options?: boolean | AddEventListenerOptions): void;
  addEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions): void;
  removeEventListener<K extends keyof AbstractWorkerEventMap>(type: K, listener: (this: SharedWorker, ev: AbstractWorkerEventMap[K]) => any, options?: boolean | EventListenerOptions): void;
  removeEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | EventListenerOptions): void;
}

interface IPlano {
  id: number;
  nomePlano: string;
  dados: {
    valor_padrao: TipoPreco;
    fidelidade: TipoPreco;
    promocao_final_temporada: TipoPreco;
    promocao_blackfriday: TipoPreco;
  };
}
interface TipoPreco {
  status: boolean;
  multiplicar: boolean;
  valores: {
    brasil: { [key: string]: string };
    estrangeiro: { [key: string]: string };
  };
}

declare var SharedWorker: {
  prototype: SharedWorker;
  new(scriptURL: string | URL, options?: string | WorkerOptions): SharedWorker;
};


namespace App {
  export class Util {
    public static readonly STATUS_CONTA_PARADA = 1;
    public static readonly STATUS_CONTA_ABERTA = 2;
    public static readonly STATUS_CONTA_EXECUCAO = 3;
    public static readonly STATUS_CONTA_VENDENDO_COINS = 4;
    public static readonly STATUS_CONTA_CAPTCHA = 458;
    public static readonly STATUS_CONTA_CAPTCHA_FALHA_AUTOCAPTCHA = 458458;
    public static readonly STATUS_CONTA_NAO_AUTENTICADA = 401;
    public static readonly STATUS_CONTA_NAO_AUTORIZADO = 403;
    public static readonly STATUS_CONTA_BANIDA = 494;

    public static readonly STATUS_POSSIVEL_SOFTBAN_COMPRA = 429;
    public static readonly STATUS_POSSIVEL_SOFTBAN_BUSCA = 512;
    public static readonly STATUS_POSSIVEL_SOFTBAN_ALTERNATIVO_1 = 426;
    public static readonly STATUS_POSSIVEL_SOFTBAN_ALTERNATIVO_2 = 521;
    public static readonly STATUS_ERROS_REPETIDOS_EM_SEQUENCIA = 999;

    public static readonly TAREFA_SNIPER = 1;
    public static readonly TAREFA_ESTIMAR_LUCRO_FILTRO = 2;

    public static readonly ID_FORNECEDOR_DSFUT = 1;
    public static readonly ID_FORNECEDOR_MYDGN = 5;

    public static readonly ARRAY_STATUS_CONTA_PREPARADA = [
      Util.STATUS_CONTA_ABERTA,
    ]

    public static readonly ARRAY_STATUS_CONTA_WEBAPP_ABERTO = [
      Util.STATUS_CONTA_ABERTA,
      Util.STATUS_CONTA_EXECUCAO,
      Util.STATUS_CONTA_VENDENDO_COINS
    ]

    public static readonly ARRAY_STATUS_CONTA_HABILITADA = [
      Util.STATUS_CONTA_ABERTA,
      Util.STATUS_CONTA_PARADA,
      Util.STATUS_CONTA_EXECUCAO,
      Util.STATUS_CONTA_VENDENDO_COINS,
    ]

    public static readonly ARRAY_STATUS_RESPONSE_CRITICO = [
      Util.STATUS_CONTA_CAPTCHA,
      Util.STATUS_CONTA_NAO_AUTENTICADA,
      Util.STATUS_CONTA_NAO_AUTORIZADO
    ];

    public static readonly EVENTO_ACAO = 0;
    public static readonly EVENTO_EXIBIR_LOG = 1;
    public static readonly EVENTO_TIPO_COMPRA = 1;
    public static readonly EVENTO_TIPO_CAPTCHA = 458;
    public static readonly EVENTO_TIPO_SOFTBAN = 512;
    public static readonly EVENTO_TIPO_ERROS_EM_SEQUENCIA = 999;
    public static readonly EVENTO_TIPO_ENVIOU_TRANSFERENCIA = 3;
    public static readonly EVENTO_INICIOU_SNIPER = 4;
    public static readonly EVENTO_PAROU_SNIPER = 5;
    public static readonly EVENTO_PAROU_SNIPER_LIMITE_ATINGIDO = 6;
    public static readonly EVENTO_PAROU_CAPACIDADE_LISTAS_ATINGIDA = 7;
    public static readonly EVENTO_TIPO_COLOCOU_A_VENDA = 8;
    public static readonly EVENTO_TENTATIVA = 9;
    public static readonly EVENTO_TIPO_ERRO = 10;
    public static readonly EVENTO_TIPO_ENVIOU_CLUBE = 11;
    public static readonly EVENTO_TIPO_RELISTOU = 12;
    public static readonly EVENTO_TIPO_LIMPAR_VENDIDOS = 13;
    public static readonly EVENTO_TIPO_LISTA_NAO_ATRIBUIDOS_CHEIA = 14;

    public static readonly EVENTO_TIPO_INCIANDO_AUTOCAPTCHA = 15;
    public static readonly EVENTO_TIPO_AUTOCAPTCHA_RESOLVIDO = 16;
    public static readonly EVENTO_TIPO_AUTOCAPTCHA_NAO_RESOLVIDO = 17;

    public static readonly EVENTO_TIPO_LUCRO_INCOMPATIVEL_COM_FILTRO = 18;
    public static readonly EVENTO_TIPO_LUCRO_FILTRO_BAIXO = 19;
    public static readonly EVENTO_TIPO_LUCRO_FILTRO_INUTIL = 20;
    public static readonly EVENTO_TIPO_LUCRO_FILTRO_ESTIMADO = 21;

    public static readonly EVENTO_TIPO_NENHUM_FILTRO_ENCONTRADO_PARA_TAREFA = 22;
    public static readonly EVENTO_TIPO_ERRO_PERMISSAO_FUTBIN = 23;

    public static readonly EVENTO_ERROR_DESCONHECIDO = 24;
    public static readonly EVENTO_ERROR_INICIAR_INSTANCIA = 25;
    public static readonly EVENTO_ERROR_INICIAR_INSTANCIA_COM_PROXY = 26;
    public static readonly EVENTO_ERROR_CONTA_NAO_HABILITADA_PARA_AGENDAMENTO = 27;

    public static readonly EVENTO_TIPO_SALDO_INSUFICIENTE = 28;
    public static readonly EVENTO_TIPO_VENDA_NAO_INFORMADA = 29;
    public static readonly EVENTO_TIPO_VENDA_BLOQUEADA = 30;
    public static readonly EVENTO_TIPO_CONTA_CARREGADA = 31;

    public static readonly EVENTO_TIPO_TRAVA_CONFERENCIA_FILTRO = 32;
    public static readonly EVENTO_TIPO_ATUALIZACAO_PRECO_COMPRA_FILTRO_LUCRO = 33;

    public static readonly EVENTO_VENDA_COINS_EXECUTADA = 34;

    public static readonly EVENTO_RELISTAGEM = 35;
    public static readonly EVENTO_REVENDA_ITENS_TRANSFERENCIA_COINS = 36;
    public static readonly EVENTO_REVENDA_ITEM_REVENDIDO = 37;

    public static readonly EVENTO_LIMITE_VENDA_ATIVA_ATINGIDO = 38;
    public static readonly EVENTO_SALDO_INSUFICIENTE_PARA_O_FILTRO = 39;
    public static readonly EVENTO_TRAVA_SEGURANCA = 40;

    public static readonly EVENTO_LIMITE_ATINGIDO = 41;
    public static readonly EVENTO_MOVE_CEMITERIO_TO_TRANSFER = 42;
    public static readonly EVENTO_VENDA_COINS_INICIADA = 43;
    public static readonly EVENTO_VENDA_COINS_INCOMPLETA = 44;
    public static readonly EVENTO_VENDA_COINS_ITEM_NAO_ENCONTRADO = 45;
    public static readonly EVENTO_AUTENTICACAO_NAO_AUTORIZADA = 46;
    public static readonly EVENTO_CARREGAMENTO_INCOMPLETO = 47;

    public static readonly EVENTO_PREVIA_PACOTE = 48;

    public static readonly EVENTO_NAVEGADOR_ABRIU = 49;
    public static readonly EVENTO_NAVEGADOR_INICIOU_WEBAPP = 50;
    public static readonly EVENTO_NAVEGADOR_FECHOU = 51;
    public static readonly EVENTO_WEBAPP_COMPLETOU_CARREGAMENTO = 52;
    public static readonly EVENTO_LOGIN_INVALIDO = 53;
    public static readonly EVENTO_AUTENTICACAO_NAO_AUTORIZADA_TROCA_PERSONA = 54;
    public static readonly EVENTO_PERSONA_SELECIONADA = 55;

    public static readonly EVENTO_CONTA_PERFIL_DEFAULT = 56;
    public static readonly EVENTO_CONTA_FILTROS_NAO_ATUALIZADOS = 57;
    public static readonly EVENTO_ERRO_SINCRONIZAR_CONTA_LOCAL = 58;
    public static readonly EVENTO_ERRO_LIMPAR_CACHE_CONTA = 59;
    public static readonly EVENTO_VENDA_COINS_ITEM_IGNORADO_POR_SEGURANCA = 60;
    public static readonly EVENTO_INSTALACAO_CHROME = 61;
    public static readonly EVENTO_BROWSERS_LIMITE_EXCEDIDO = 62;
    public static readonly EVENTO_CONTA_BANIDA_IDENTIFICADA_COM_MERCADO = 63;

    public static readonly EVENTO_AUTODME_DME_NAO_ENCONTRADO = 64;
    public static readonly EVENTO_AUTODME_DME_RESOLVIDO = 65;
    public static readonly EVENTO_PACOTE_ANALISE = 66;
    public static readonly EVENTO_AUTODME_ACOES = 67;
    public static readonly EVENTO_PACOTE_ABERTO = 68;
    public static readonly EVENTO_RELISTAGEM_DESCARTE = 69;
    public static readonly EVENTO_CONTA_ABERTA_COM_RESOLVER_BUG_EA = 70;

    public static readonly EVENTO_FILTROS_DEFINIDOS = 71;
    public static readonly EVENTO_ERRO_AUTENTICACAO = 72;
    public static readonly EVENTO_FILTRO_NAO_PASSOU_NA_CONFERENCIA = 73;
    public static readonly EVENTO_FILTRO_AJUSTE_DE_LIMITE = 74;

    public static readonly ACAO_COMUNICACAO_GET_CONTAS = 1;
    public static readonly ACAO_COMUNICACAO_GET_CONSOLIDADOS = 2;
    public static readonly ACAO_COMUNICACAO_GET_AGENDAMENTOS = 3;
    public static readonly ACAO_COMUNICACAO_GET_LOGS = 4;
    public static readonly ACAO_COMUNICACAO_INICIAR_CONTA = 5;
    public static readonly ACAO_COMUNICACAO_PARAR_TAREFA = 6;
    public static readonly ACAO_COMUNICACAO_FECHAR_CONTA = 7;
    public static readonly ACAO_COMUNICACAO_CREDENCIAIS = 8;
    public static readonly ACAO_COMUNICACAO_ATUALIZAR_CONTA = 9;
    public static readonly ACAO_COMUNICACAO_SNIPAR = 10;
    public static readonly ACAO_COMUNICACAO_INTERACAO_SNIPER = 11;
    public static readonly ACAO_COMUNICACAO_TESTE = 12;
    public static readonly ACAO_COMUNICACAO_CANCELAR_VENDA_COINS = 13;
    public static readonly ACAO_COMUNICACAO_UPDATE_EXECUCAO_CONTA = 14;
    public static readonly ACAO_COMUNICACAO_GET_ESTATISTICAS_CONTA = 15;
    public static readonly ACAO_COMUNICACAO_GET_JOGADORES_PARA_SNIPAR = 16;
    public static readonly ACAO_COMUNICACAO_INICIAR_TAREFA_IMEDIATA = 17;
    public static readonly ACAO_COMUNICACAO_MOSTRAR_WEBAPP = 18;
    public static readonly ACAO_LIGAR_DESLIGAR_TAREFA = 19;
    public static readonly ACAO_COMUNICACAO_SALVAR_CONFIG_GERAL = 20;
    public static readonly ACAO_COMUNICACAO_ATUALIZAR_CONTAS_VINCULADAS = 21;
    public static readonly ACAO_COMUNICACAO_GET_CONFIGURACAO_GERAL = 22;
    public static readonly ACAO_COMUNICACAO_EXECUTAR_ACAO_UNICA = 23;
    public static readonly ACAO_COMUNICACAO_AJUSTAR_LUCRO = 24;
    public static readonly ACAO_COMUNICACAO_ABRIR_CONTAS = 25;
    public static readonly ACAO_COMUNICACAO_VINCULAR_MULT_CONTAS = 26;
    public static readonly ACAO_COMUNICACAO_EXCLUIR_CONTA = 27;
    public static readonly ACAO_COMUNICACAO_GET_ENCONTRADOS_POR_FILTRO = 28;
    public static readonly ACAO_COMUNICACAO_TESTE_NOTIFICACAO_TELEGRAM = 29;
    public static readonly ACAO_COMUNICACAO_GET_FILTRO_MULT_RARIDADE_FUTBIN = 30;
    public static readonly ACAO_COMUNICACAO_LIMPAR_LIMITES_CONTAS = 31;
    public static readonly ACAO_COMUNICACAO_LIMPAR_LOGS = 32;
    public static readonly ACAO_COMUNICACAO_GET_DELAY = 33;
    public static readonly ACAO_COMUNICACAO_INTERROMPER_FECHAR_CONTAS = 34;
    public static readonly ACAO_COMUNICACAO_REINICIAR_PLUGIN = 35;
    public static readonly ACAO_COMUNICACAO_OBTER_DADOS_FILTRO_FUTBIN = 36;
    public static readonly ACAO_COMUNICACAO_LIMPAR_CACHE_CONTAS = 37;
    public static readonly ACAO_COMUNICACAO_SINCRONIZAR_DATABASE_CONTAS_PLUGIN = 38;
    public static readonly ACAO_COMUNICACAO_LIMPEZA_DESFRAGMENTACAO_DE_DISCO = 39;
    public static readonly ACAO_COMUNICACAO_EXPORTAR_DATABASE_LOCAL = 40;
    public static readonly ACAO_COMUNICACAO_CRIAR_INICIALIZACAO_AUTOMATICA_PLUGIN = 41;
    public static readonly ACAO_COMUNICACAO_REINICIAR_WINDOWS = 42;
    public static readonly ACAO_COMUNICACAO_REMOVER_INICIALIZACAO_AUTOMATICA_PLUGIN = 43;
    public static readonly ACAO_COMUNICACAO_RESOLVER_DME_CONTAS = 44;

    public static readonly ID_TIPO_ACAO_UNICA_VENDER_COINS_NA_CONTA = 1;
    public static readonly ID_TIPO_ACAO_UNICA_LIMPAR_CACHE_CONTA = 2;
    public static readonly ID_TIPO_ACAO_UNICA_LIMPAR_DADOS_BROWSER_CONTA = 3;
    public static readonly ID_TIPO_ACAO_UNICA_ATUALIZAR_INFO_JOGADORES_CLUBE = 4;
    public static readonly ID_TIPO_ACAO_UNICA_RESOLVER_CAPTCHA_AUTOMATICAMENTE = 5;
    public static readonly ID_TIPO_ACAO_UNICA_RESOLVER_DME = 8;
    public static readonly ID_TIPO_ACAO_UNICA_RESOLVER_BUG_CONTA_EA = 9;

    public static readonly ARRAY_DIAS_AGENDAMENTO = [
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sábado",
      "Domingo",
      "Todo dia",
    ];
    public static locate: string = 'pt-br';
    public static versaoFifaAtual: string = '20';
    public static tipoExibicaoValidacaoFormularioSuperior: string = 'superior';
    public static tipoExibicaoValidacaoFormularioCampoACampo: string = 'campoacampo';
    public static tipoExibicaoValidacaoFormulario: string;
    public static tipoAlertaSuperior: string = 'superior';
    public static tipoAlertaInferior: string = 'inferior';

    public static corVerdePadrao: string = "#31C68B";

    public static tipoMensagemInfo: string = "info";
    public static tipoMensagemSuccess: string = "success";
    public static tipoMensagemDanger: string = "danger";
    public static tipoMensagemWarning: string = "warning";
    private static elSpinner: JQuery = $("#spinnerSniper");
    private static spinnerSniperTableContas: JQuery = $("#spinnerSniperTableContas");

    private planos: IPlano[] = null;

    public static mensagensRetorno: string = "";
    public static contextoFormAtual: JQueryEventObject;
    public static ehValidacaoCampoACampo: boolean;
    public static exibirSweetAlerta: any = null;
    public static usuario: IUsuario = null;
    public static config: IConfig = null;
    public static ehIframe: boolean = false;
    public static elencoDme: IRetornoElencoDme = null;
    public static exibirDialogoSweetAlerta: any = null;
    public static exibirAlertaNotificacao: any = null;
    public static alertaNotificacao: IAlertaNotificacaoToastrOptions = null;
    private static dados: any = [];
    private static ehSite: boolean;
    private static ehApp: boolean;
    private static auctionMaxBid: number = 15000000;
    private static pricesTiers: any = [{ min: 1e5, inc: 1e3 }, { min: 5e4, inc: 500 },
    { min: 1e4, inc: 250 }, { min: 1e3, inc: 100 },
    { min: 150, inc: 50 }, { min: 0, inc: 150 }];

    public static loadCarregamentoId: number = null
    public static editarPrecoJogadoresSelecionados: boolean = false

    public static objPlayers: IPlayerJson[] = [];
    public static objJogadorDefault: any = { "f": "Não", "id": 0, "l": "Identificado", "r": 0 };

    public static readonly ID_MENSAGEM_RESPOSTA_PREVIA_PACOTE_INICIADA = 1;
    public static readonly ID_MENSAGEM_RESPOSTA_PREVIA_PACOTE_RECEBIDA = 2;
    public static readonly ID_MENSAGEM_RESPOSTA_PREVIA_PACOTE_SALDO_INSUFICIENTE = 3;
    public static readonly ID_MENSAGEM_RESPOSTA_PREVIA_PACOTE_NAO_LUCRATIVA = 4;
    public static readonly ID_MENSAGEM_RESPOSTA_PREVIA_PACOTE_COMPRADA = 5;
    public static readonly ID_MENSAGEM_RESPOSTA_PREVIA_PACOTE_ERROR = 6;
    public static readonly ID_MENSAGEM_RESPOSTA_PREVIA_PACOTE_ITENS_NAO_ATRIBUIDOS = 7;

    public static readonly ID_MENSAGEM_CONFERENCIA_FILTRO_FILTROS_INATIVOS = 1;
    public static readonly ID_MENSAGEM_CONFERENCIA_FILTRO_SEM_PRECO_COMPRA = 2;
    public static readonly ID_MENSAGEM_CONFERENCIA_FILTRO_SALDO_INSUFICIENTE = 3;
    public static readonly ID_MENSAGEM_CONFERENCIA_FILTRO_MUITOS_ITENS = 4;

    public static readonly URL_API_IPIFY = `https://api.ipify.org?format=json`;
    public static readonly URL_FUTBIN_ORG_API = `https://www.futbin.org/futbin/api/`;

    public static readonly ID_TIPO_FILTRO_WEBAPP_RARIDADE = 1;

    public static strContains(stringCompare: string, stringContains: string | any) {
      if ($.isArray(stringContains)) {
        let containsStr = false;
        $.each(stringContains, function (chave, valor) {
          if (stringCompare.indexOf(valor) != -1) {
            containsStr = true;
          }
        });
        return containsStr;
      }
      return stringCompare.indexOf(stringContains) != -1;;
    }

    public static setLocate(locate: string) {
      App.Util.locate = locate;
    }
    public static setSweetAlerta(exibirSweetAlerta: string) {
      App.Util.exibirSweetAlerta = exibirSweetAlerta;
    }
    public static setDialogoSweetAlerta(exibirDialogoSweetAlerta: string) {
      App.Util.exibirDialogoSweetAlerta = exibirDialogoSweetAlerta;
    }
    public static setAlertaNotificacao(exibirAlertaNotificacao: string) {
      App.Util.exibirAlertaNotificacao = exibirAlertaNotificacao;
    }
    public static setConfig(dadosConfig: any) {
      App.Util.config = dadosConfig;
      App.Util.usuario = dadosConfig.usuario;
    }
    public static setElencoDme(elenco: any) {
      App.Util.elencoDme = elenco;
    }

    private static processarContexto() {
      var contexto = $('body').data('contexto');
      this.ehSite = contexto == 'site';
      this.ehApp = contexto == 'app';
    }
    public static checkIframe() {
      App.Util.ehIframe = window.location !== window.parent.location;
      if (App.Util.ehIframe) {
        $('.btn-acessar-sniper-extensao').show();
        $('.btn-google').attr('target', '_blank');
      } else {
        $('.menu-recarregar-extensao').hide();
      }
    }

    public static iniciarModulo(nomeModulo: string, incluirConfig = false) {

      if (incluirConfig) {
        App.Util.exibirModalPaginaCarregando();
        $.ajax({
          url: "/23YTDfhgtPxResdcTr345fdf/KUULtGnX0hwaqvRx39le1A",
          type: 'GET',
          contentType: 'application/json',
          beforeSend: function (jqXHR, settings) {
            jqXHR.setRequestHeader('X-CSRF-TOKEN', $('meta[name=csrf-token]').attr("content"));
          },
          success: (dadosConfig) => {
            App.Util.setConfig(dadosConfig)
            App.Util.continuarInicializacao(nomeModulo);
          },
          error: (jqXHR, textStatus, errorThrown) => {
          }
        });
      } else {
        App.Util.continuarInicializacao(nomeModulo);
      }
    }

    private static continuarInicializacao(nomeModulo: string): void {
      App.Util.checkIframe();
      if (nomeModulo != "") {
        (App.Modulos as any)[nomeModulo].inicializar();
      }
      this.inicializarJqueryMetodosExtends();
      this.processarContexto();
      this.tipoExibicaoValidacaoFormulario = this.tipoExibicaoValidacaoFormularioCampoACampo;
      this.ehValidacaoCampoACampo = App.Util.tipoExibicaoValidacaoFormulario == App.Util.tipoExibicaoValidacaoFormularioCampoACampo;
      $('.alerta-barra-acoes .close').on('click', (e) => { this.aoOcultarAlertaAcoes(e); });
      $('.input-group.padrao > input').on('focus', (e) => { this.aoFocarCampoGroupAddon(e); });
      $('.input-group.padrao > input').on('focusout', (e) => { this.aoDesfocarCampoGroupAddon(e); });
      $('.fechar-notificacao').on('click', (e) => { this.marcarNotificacaoComoLida(e); });

      this.alertaNotificacao = new AlertaNotificacaoToastr();
      this.alertaNotificacao.inicializarComponente();
      this.processarAlertas();

      this.inicializarHoverDropDown();
      this.inicializarSelect2Config();
      this.inicializarToastr();
      this.inicializarPluginsData();
      if ($(".video-modal-como-utilizar").length > 0) {
        var video = new Video();
        video.inicializar($(".video-modal-como-utilizar"));
      }
    }

    private static aoFocarCampoGroupAddon(e: JQueryEventObject): void {
      $(e.target).parents(".input-group").find('.input-group-addon').addClass("focus");
    }
    private static aoDesfocarCampoGroupAddon(e: JQueryEventObject): void {
      $(e.target).parents(".input-group").find('.input-group-addon').removeClass("focus");
    }
    public static processarAlertas(): void {
      if (App.Util.exibirSweetAlerta != null) {
        var mensagem: ISweetAlerta = App.Util.exibirSweetAlerta;
        App.Util.exebirSweetAlerta(mensagem.titulo, mensagem.mensagem, mensagem.tipoAlerta, mensagem.dadosAlerta);
      }
      if (App.Util.exibirDialogoSweetAlerta != null) {
        var mensagemDialogo: IDialogoSweetAlerta = App.Util.exibirDialogoSweetAlerta;
        App.Util.exibirSweetConfirmacaoAjax(mensagemDialogo.urlCallback, mensagemDialogo.urlCallbackCancela, mensagemDialogo.titulo, mensagemDialogo.mensagem, mensagemDialogo.textoBotaoConfirmacao);
      }

      if (App.Util.exibirAlertaNotificacao != null) {
        var notificacao: IAlertaNotificacao = App.Util.exibirAlertaNotificacao;
        Util.exibirAlertaToastr(notificacao);

      }
    }

    public static exibirAlertaToastr(notificacao: IAlertaNotificacao): void {
      switch (notificacao.tipo) {
        case 'success':
          this.alertaNotificacao.exibirSucesso(notificacao.titulo, notificacao.mensagem);
          break;
        case 'info':
          this.alertaNotificacao.exibirInfo(notificacao.titulo, notificacao.mensagem);
          break;
        case 'warning':
          this.alertaNotificacao.exibirAtencao(notificacao.titulo, notificacao.mensagem);
          break;
        case 'error':
          this.alertaNotificacao.exibirErro(notificacao.titulo, notificacao.mensagem);
          break;
      }
    }

    public static inicializarPluginsData(): void {
      $('.datepicker-input').datepicker({
        format: 'dd/mm/yyyy',
        language: 'pt-BR',
        todayBtn: "linked",
        keyboardNavigation: false,
        forceParse: false,
        calendarWeeks: true,
        autoclose: true
      });
    }

    public static verificarSessaoLoginPorClick(arrayClassesQueAcionaVerificacao: string[] = []): void {
      $(document).on('click', (event) => {
        if ($(event.target).hasClasses(arrayClassesQueAcionaVerificacao)) {
          var ajax: IAjax;
          ajax = new App.Ajax();
          ajax.recarregarNaoLogado()
        }
      });
    }

    public static inicializarJqueryMetodosExtends(): void {
      $.fn.extend({
        hasClasses: function (selectors: any) {
          var self = this;
          for (var i in selectors) {
            if ($(self).hasClass(selectors[i]))
              return true;
          }
          return false;
        }
      });

      $.fn.orderChildren = function (order: any) {
        this.each(function () {
          var el = $(this);
          for (var i = order.length - 1; i >= 0; i--) {
            el.prepend(el.children(order[i]));
          }
        });
        return this;
      };
    }

    public static inicializarJqueryValidate(): void {
      $.extend(jQuery.validator.messages, {
        required: "Este campo &eacute; obrigatório.",
        remote: "Por favor, corrija este campo.",
        email: "Por favor, forne&ccedil;a um endere&ccedil;o eletr&ocirc;nico v&aacute;lido.",
        url: "Por favor, forne&ccedil;a uma URL v&aacute;lida.",
        date: "Por favor, forne&ccedil;a uma data v&aacute;lida.",
        dateISO: "Por favor, forne&ccedil;a uma data v&aacute;lida (ISO).",
        number: "Por favor, forne&ccedil;a um n&uacute;mero v&aacute;lido.",
        digits: "Por favor, forne&ccedil;a somente d&iacute;gitos.",
        creditcard: "Por favor, forne&ccedil;a um cart&atilde;o de cr&eacute;dito v&aacute;lido.",
        equalTo: "Os valores dos campos não coincidem.",
        accept: "Por favor, forne&ccedil;a um valor com uma extens&atilde;o v&aacute;lida.",
        maxlength: jQuery.validator.format("Por favor, forne&ccedil;a n&atilde;o mais que {0} caracteres."),
        minlength: jQuery.validator.format("Por favor, forne&ccedil;a ao menos {0} caracteres."),
        rangelength: jQuery.validator.format("Por favor, forne&ccedil;a um valor entre {0} e {1} caracteres de comprimento."),
        range: jQuery.validator.format("Por favor, forne&ccedil;a um valor entre {0} e {1}."),
        max: jQuery.validator.format("Por favor, forne&ccedil;a um valor menor ou igual a {0}."),
        min: jQuery.validator.format("Por favor, forne&ccedil;a um valor maior ou igual a {0}.")
      });

      $.validator.addMethod("dateBR", function (value, element) {
        if (value == null || value == "") {
          return true;
        }
        if (value.length != 10) return false;
        // verificando data
        var data = value;
        var dia = data.substr(0, 2);
        var barra1 = data.substr(2, 1);
        var mes = data.substr(3, 2);
        var barra2 = data.substr(5, 1);
        var ano = data.substr(6, 4);
        if (data.length != 10 || barra1 != "/" || barra2 != "/" || isNaN(dia) || isNaN(mes) || isNaN(ano) || dia > 31 || mes > 12) return false;
        if ((mes == 4 || mes == 6 || mes == 9 || mes == 11) && dia == 31) return false;
        if (mes == 2 && (dia > 29 || (dia == 29 && ano % 4 != 0))) return false;
        if (ano < 1900) return false;
        return true;
      }, "Informe uma data válida");  // Mensagem padrão

      $.validator.addMethod("dataMenor", function (value, element, params) {
        var dataInicio = $(params).val();
        var dataFim = value;
        var partsInicio = dataInicio.split("/");
        var partsFim = dataFim.split("/");
        return this.optional(element) || new Date(Number(partsFim[2]), Number(partsFim[1]) - 1, Number(partsFim[0])) > new Date(Number(partsInicio[2]), Number(partsInicio[1]) - 1, Number(partsInicio[0]));
      }, 'Data deve ser maior que data inicial.');

      $.validator.addMethod("emailValido", function (value, element) {
        return this.optional(element) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@(?:\S{1,63})$/.test(value);
      }, 'Informe um e-mail válido.');

      $.validator.addMethod("noEmpty", function (value, element) {
        return !(!$.trim(value));
      }, "Este campo &eacute; obrigatório.");

      $.validator.addMethod("requireOne", function (value: any, element: any) {
        return $('.require-one:checkbox:checked').length > 0
      }, "Você precisa escolher um item.");
    }

    public static exibirSweetAlertaFireSimples(titulo: string, texto: string, tipo: string = null): void {
      swal.fire({
        icon: tipo,
        title: titulo,
        text: texto
      })
    }
    public static exebirSweetAlerta(titulo: string, texto: string, tipo: string = null, dadosAlerta: any = null): void {
      var dados: ISwal = {
        title: titulo,
        text: texto,
        confirmButtonColor: "#22B87E",
        confirmButtonText: "Fechar"
      }

      if (tipo) {
        dados.type = tipo;
      }
      if (dadosAlerta && dadosAlerta.hasOwnProperty("html")) {
        dados.html = dadosAlerta.html;
      }

      try {
        swal(dados);
      } catch (e) {
        console.log("erro versao swal", e);
        swal.fire(dados)
      }

    }

    public static exibirSweetConfirmacaoAjax(urlCallback: string, urlCallbackCancela: string, titulo: string, texto: string, textoBotaoConfirmacao: string = "Sim, continuar!", corBotaoConfirmacao: string = "#DD6B55"): void {
      swal({
        title: titulo,
        text: texto,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: corBotaoConfirmacao,
        confirmButtonText: textoBotaoConfirmacao,
        cancelButtonText: "cancelar",
        closeOnConfirm: true
      },
        function (isConfirm: boolean) {
          var ajax: IAjax;
          ajax = new App.Ajax();
          var dados: any = {};
          if (isConfirm) {
            ajax.postAcao(urlCallback, dados);
          } else {
            ajax.postAcao(urlCallbackCancela, dados);
          }
        });
    }

    public static exibirSweetConfirmacaoHtmlNovaVersao(e: JQueryEventObject, titulo: string, texto: string, textoBotaoConfirmacao: string = "Sim, continuar!", metodoAexecutarAposConfirmacao: any, corBotaoConfirmacao: string = "#DD6B55"): void {
      swal.fire({
        title: titulo,
        html: texto,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: corBotaoConfirmacao,
        confirmButtonText: textoBotaoConfirmacao,
        cancelButtonText: "cancelar",
        closeOnConfirm: true
      }).then((result: any) => {
        if (result.isConfirmed) {
          metodoAexecutarAposConfirmacao(e);
        }
      });
    }

    public static exebirSweetConfirmacaoHtml(e: JQueryEventObject, titulo: string, texto: string, textoBotaoConfirmacao: string = "Sim, continuar!", metodoAexecutarAposConfirmacao: any, corBotaoConfirmacao: string = "#DD6B55"): void {
      swal({
        title: titulo,
        html: texto,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: corBotaoConfirmacao,
        confirmButtonText: textoBotaoConfirmacao,
        cancelButtonText: "cancelar",
        closeOnConfirm: true
      }).then((result: any) => {
        if (result.value) {
          metodoAexecutarAposConfirmacao(e);
        }
      });
    }

    public static exebirSweetConfirmacao(e: JQueryEventObject | any, titulo: string, texto: string, textoBotaoConfirmacao: string = "Sim, continuar!", metodoAexecutarAposConfirmacao: any, corBotaoConfirmacao: string = "#DD6B55"): void {
      swal({
        title: titulo,
        text: texto,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: corBotaoConfirmacao,
        confirmButtonText: textoBotaoConfirmacao,
        cancelButtonText: "cancelar",
        closeOnConfirm: true
      }).then((result: any) => {
        if (result.value) {
          metodoAexecutarAposConfirmacao(e);
        }
      });
    }

    public static processarSucessoRequisicaoAjax(e: JQueryEventObject, dados: IRespostaAjax, status: any, jqXHR: any): void {
      if (!dados.hasOwnProperty("titulo") && !dados.hasOwnProperty("mensagem")) {
        return;
      }
      if (dados.hasOwnProperty("tipo")) {
        this.exibirAlertaToastr(dados);
      } else {
        /**
         * Para exibir uma barra simples de alerta
         * App.Util.exibirMensagemAlerta(dados.mensagem, App.Util.tipoMensagemSuccess, App.Util.tipoAlertaInferior);
         */
        App.Util.exebirSweetAlerta(dados.titulo, dados.mensagem, "success", dados.dadosAlerta);
        if (dados.resetarCamposFormulario) {
          App.Util.limparCamposFormulario(e);
        }

        if (e) {
          App.Util.limparErrosDoFormulario(e);
          App.Util.ocultarMensagemFormulario(e);
        }
      }
    }

    public static processarErroRequisicaoAjax(e: JQueryEventObject, jqXHR: any, status: any, error: any): void {
      App.Util.exibirMensagemFormulario(e, jqXHR);
    }

    public static completarProcessoRequisicaoAjax(e: JQueryEventObject): void {

    }

    public static preparaCabecalhoRequisicaoAjax(): void {
      $.ajaxSetup({
        headers: {
          'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr("content")
        },
        contentType: 'application/json'
      });
    }

    /**
     * Substitui determinado valor por outro valor escolhido
     * dentro do texto informado.
     * @param string find Valor a ser encontrado para ser substituído
     * @param string replace Valor de substituição
     * @param string text Texto informado para receber a subtituição.
     * @returns string texto com valores substituídos.
     */
    public static replaceAll(find: string, replace: string, text: string): string {
      return text.replace(new RegExp(find, 'g'), replace);
    }

    public static validaEmail(email: string): boolean {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    /**
     * Remove caracteres especiais e espaços retornando uma string
     * limpa
     */
    public static removerCaracteresEspeciais(valor: string): string {
      valor = valor.replace(/[ÀÁÂÃÄÅ]/, "A");
      valor = valor.replace(/[àáâãäå]/, "a");
      valor = valor.replace(/[ÈÉÊË]/, "E");
      valor = valor.replace(/[Ç]/, "C");
      valor = valor.replace(/[ç]/, "c");

      return valor.replace(/[^a-z0-9]/gi, '');
    }

    public static removeAspasEAcentos(str: any): string {
      // Remover aspas simples e duplas
      str = str.replace(/['"]/g, '');
      // Remover acentuações
      str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return str;
    }

    public static validaData(data: string): boolean {
      var arrData: any = data.split("/");
      var dia: any = ("00" + arrData[0]).substring(arrData[0].length);
      var mes: any = ("00" + arrData[1]).substring(arrData[1].length);
      var ano: any = arrData[2];
      if (dia.toString().trim() !== '' && mes.toString().trim() !== '' && ano.toString().trim() !== '') {
        //Verifica se o ano está correto
        if (ano.length == 4 && ano > 1900 && ano < 2100) {
          // Verificando o intervalo permitido para os valores dos meses e dias
          if (dia > 0 && dia <= 31 && mes > 0 && mes <= 12) {
            // Verifica os meses que posuem dia 30 dias
            if ((mes == 4 || mes == 6 || mes == 9 || mes == 11) && dia > 30) {

              return false;
            }
            // caso seja mês 2 verifica se o ano é bissexto
            if (mes == 2) {
              //se for bissexto
              if (ano % 4 == 0 && (ano % 100 != 0 || ano % 400 == 0)) {
                // Se for bissexto pode o dia ser no máximo 29
                if (dia > 29)
                  return false;
                // se não for bisexto o dia pode ser no máximo 28
              } else if (dia > 28) {

                return false;
              }
            }
          } else {
            return false;
          }
          // Data válida
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    public static adicionarProgressoElemento(elementoExibir: JQuery, configuracoes: Object = Util.obterConfiguracoesElementoProgresso()) {
      var container: HTMLElement = elementoExibir[0];
      var spinner = new Spinner(configuracoes).spin(container);
      return spinner;
    }

    public static obterConfiguracoesElementoProgresso(): SpinnerOptions {
      var configuracoes: SpinnerOptions = {
        lines: 9 // The number of lines to draw
        , length: 0 // The length of each line
        , width: 3 // The line thickness
        , radius: 46 // The radius of the inner circle
        , scale: 1 // Scales overall size of the spinner
        , corners: 0.9 // Corner roundness (0..1)
        , color: '#fff' // #rgb or #rrggbb or array of colors
        , opacity: 0.25 // Opacity of the lines
        , rotate: 40 // The rotation offset
        , direction: 1 // 1: clockwise, -1: counterclockwise
        , speed: 1.6 // Rounds per second
        , trail: 60 // Afterglow percentage
        , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
        , zIndex: 2e9 // The z-index (defaults to 2000000000)
        , className: 'spinner' // The CSS class to assign to the spinner
        , top: '49%' // Top position relative to parent
        , left: '50%' // Left position relative to parent
        , shadow: false // Whether to render a shadow
        , hwaccel: false // Whether to use hardware acceleration
        , position: 'absolute' // Element positioning
      };
      return configuracoes;
    }

    public static exibirModalPaginaCarregando(id: number = null): void {
      Util.loadCarregamentoId = id
      $('#carregando').modal('show');
    }

    public static ocultarModalPaginaCarregando(): void {
      $('#carregando').modal('hide');
      setTimeout(function () { $('#carregando').modal('hide'); }, 500);
    }

    public static exibirMensagemAlerta(mensagem: string, tipoMensagem: string = App.Util.tipoMensagemInfo, tipoAlerta: string = App.Util.tipoAlertaSuperior, fecharMensagemAutomaticamente: boolean = true): void {
      var selector = '#alerta-barra-acoes-' + tipoAlerta;
      $(selector + ' .alert').addClass('alert-' + tipoMensagem);
      $(selector + ' .mensagem').html(mensagem);
      $(selector).removeClass('hide');
      if (fecharMensagemAutomaticamente) {
        setTimeout(function () { App.Util.ocultarMensagemAlerta() }, 7000);
      }
    }

    public static ocultarMensagemAlerta(e: JQueryEventObject = null): void {
      $('.alerta-barra-acoes .close').click();
    }

    public static aoOcultarAlertaAcoes(e: JQueryEventObject): void {
      var elemento = $(e.target).parents('.alerta-barra-acoes');
      $(elemento).find('.alert').removeClass().addClass('alert');
      $(elemento).find('.mensagem').html('');
      $(elemento).addClass('hide');
    }

    public static limparCamposFormulario(e: JQueryEventObject) {
      $(e.target).trigger("reset");
    }

    public static ocultarMensagemFormulario(e: JQueryEventObject) {
      var alerta = $(e.target).find('.alert-ajax');
      var conteudo = alerta.find('ul');
      conteudo.html('');
      alerta.addClass('hidden');
    }

    public static limparErrosDoFormulario(e: JQueryEventObject) {
      var elementoFormulario = $(e.target);
      elementoFormulario.find('.form-group').removeClass('has-error');
      elementoFormulario.find('.error').addClass('hide');
    }

    public static atribuirErroAoCampo(campo: string, valor: string) {
      var elementoCampo = $('[name=' + campo + ']');
      if (elementoCampo.length > 0) {
        var formGroup = elementoCampo.parents('.form-group');
        formGroup.addClass('has-error');
        var error = formGroup.find('.error');
        error.removeClass('hide').css('display', 'block');
        error.html(valor);
      }
    }
    public static atribuirErroAoElementoCampo(campo: JQuery, mensagem: string) {
      campo.parent(".form-group").addClass('has-error').removeClass('hide');
      campo.parent(".form-group").find('.error').removeClass('hide').html(mensagem);
    }
    public static atribuirErroAoCampoChosen(campo: string, valor: string) {
      $(campo).addClass('has-error');
      var erro: any = $(campo).find('.error');
      erro.removeClass('hide').css('display', 'block');
      erro.html(valor);
    }

    public static exibirMensagemFormulario(e: JQueryEventObject, jqXHR: any) {
      var erros: any[] = jqXHR.responseJSON;
      if (this.ehValidacaoCampoACampo) {
        App.Util.limparErrosDoFormulario(e);
        $.each(erros, App.Util.encontrarMensagensDeResposta);
        return;
      }

      var alerta = $(e.target).find('.alert-ajax');
      var conteudo = alerta.find('ul');
      conteudo.html('');
      $.each(erros, App.Util.encontrarMensagensDeResposta);
      conteudo.append(App.Util.mensagensRetorno);
      App.Util.mensagensRetorno = "";
      alerta.animate({ scrollTop: 0 }, 500).removeClass('hidden');
    }

    private static encontrarMensagensDeResposta(chave: any, valor: any) {
      if (valor instanceof Object) {
        var campo = chave;
        $.each(valor, function (chave, valor) {
          if (App.Util.ehValidacaoCampoACampo) {
            App.Util.atribuirErroAoCampo(campo, valor);
          }
          App.Util.encontrarMensagensDeResposta(chave, valor);
        });
        return;
      }

      App.Util.mensagensRetorno += '<li>' + valor + '</li>';
    }

    public static inicializarCampoChosen(seletor: string, campoCargos: string, seletorProximoFocu: string, maximoOpcoesSelecionadas: number = 5, textoNaoResultado: string = "Dado não encontrado", funcaoAposLimiteNaoPermitido: any) {
      $(seletor).chosen({ width: "100%", max_selected_options: maximoOpcoesSelecionadas, disable_search_threshold: maximoOpcoesSelecionadas, no_results_text: textoNaoResultado })
        .change(function (event) {
          if (event.target == this) {
            $('input[name=' + campoCargos + ']').val($(this).val());
          }
        });

      $(seletor).bind("chosen:maxselected", () => {
        if ($(seletorProximoFocu).length > 0) {
          $(seletorProximoFocu).focus();
        }
        funcaoAposLimiteNaoPermitido();
      });
    }

    public static obterQuantidadeItensAdicionados(seletor: string): number {
      var quantidade: number = 0;
      $(seletor + " .itens-selecionados").find('.item-removivel').each(function () {
        quantidade += 1;
      });

      return quantidade;
    }

    public static removerItem(e: JQueryEventObject, seletor: string) {
      e.preventDefault();
      $(e.target).parents('.item-removivel').remove();
    }

    public static ehCampoTextoVazio(campo: JQuery) {
      return !$.trim(campo.val());
    }
    public static empty(param: any) {
      if ($.isArray(param)) {
        return param.length <= 0;
      }
      var variavel = $.trim(param);
      return typeof variavel == 'undefined' || variavel === null || variavel == "" || variavel == 'NaN';
    }
    public static ehCampoSelectVazio(campo: JQuery) {
      return campo.val() == "";
    }

    public static ehVariavelValidaNaoVazia(variavel: any) {
      if (typeof variavel == 'undefined' || variavel === null || isNaN(variavel) || variavel.toString().trim() == "") {
        return false;
      }
      return true;
    }

    public static resetarErrosForm(elemento: JQuery) {
      elemento.find('form span.error').html('').css('display', 'none');
      elemento.find('form label.error').html('').remove();
      elemento.find('form .form-control.error').removeClass('error');
    }

    public static validacaoPadrao(form: any) {
      form.validate({
        errorElement: 'span'
      });
    }
    public static validacaoPadraoRealocandoErro(form: any, seletor: string) {
      form.validate({
        errorElement: 'span',
        errorPlacement: (error: any, element: any) => {
          error.insertAfter(seletor);
        }
      });
    }

    public static exibirLoadingSniperApp() {
      this.elSpinner.show();
    }

    public static ocultarLoadingSniperApp() {
      this.elSpinner.hide();
    }
    public static exibirLoadingTableContas() {
      this.spinnerSniperTableContas.show();
    }

    public static ocultarLoadingTableContas() {
      this.spinnerSniperTableContas.hide();
    }
    public static inicializarHoverDropDown() {
      $('.btn-group.tipo-hover').hover(function () {
        $(this).find('.dropdown-menu').stop(true, true).fadeIn(400);
      }, function () {
        $(this).find('.dropdown-menu').stop(true, true).fadeOut(400);
      });
    }
    public static refreshAnimation(wizard: any, index: any) {
      var total = wizard.find('.nav li').length;
      var li_width = 100 / total;

      var total_steps = wizard.find('.nav li').length;
      var move_distance = wizard.width() / total_steps;
      var index_temp = index;
      var vertical_level = 0;

      var mobile_device = $(document).width() < 600 && total > 3;

      if (mobile_device) {
        move_distance = wizard.width() / 2;
        index_temp = index % 2;
        var li_width = 50;
      }

      wizard.find('.nav li').css('width', li_width + '%');

      var step_width = move_distance;
      move_distance = move_distance * index_temp;

      var current = index + 1;

      if (current == 1 || (mobile_device == true && (index % 2 == 0))) {
        move_distance -= 8;
      } else if (current == total_steps || (mobile_device == true && (index % 2 == 1))) {
        move_distance += 8;
      }

      if (mobile_device) {
        var vertical_level: number = index / 2;
        vertical_level = vertical_level * 38;
      }

      wizard.find('.moving-tab').css('width', step_width);
      $('.moving-tab').css({
        'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
        'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

      });
    }

    public static parseMinutosParaMilisegundos(minutos: number) {
      return minutos * 60000;
    }

    public static parseMilisegundosParaSegundos(milisegundos: number) {
      return milisegundos / 1000;
    }

    public static parseSegundosParaMilisegundos(segundos: number) {
      return segundos * 1000;
    }

    public static parseSegundosParaMinutos(segundos: number) {
      return Math.floor(segundos % 3600 / 60);
    }

    public static parseSegundosParaHoras(segundos: number) {
      return Math.floor(segundos / 3600);
    }

    public static parseMilisegundosParaMinutos(milisegundos: number) {
      return milisegundos / 60000;
    }

    public static inArray(valor: any, array: any) {
      return $.inArray(valor, array) > -1
    }
    public static inicializarSelect2Config() {
      if (this.ehApp) {
        if ($(".select-img").length > 0) {
          $(".select-img").select2({
            width: '100%',
            templateResult: formatOptionsSelect,
            templateSelection: formatOptionsSelect
          });
        }
      }

    }
    public static inicializarToastr() {
      toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-bottom-center",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
      }

    }

    public static playAudioCompra() {
      var audio = new Audio('/audios/1.mp3');
      audio.play();
    }
    public static playAudioParouCompra() {
      var audio = new Audio('/audios/2.mp3');
      audio.play();
    }
    public static playAudioCaptcha() {
      var audio = new Audio('/audios/3.mp3');
      audio.play();
    }
    public static playAudioGanhouLance() {
      var audio = new Audio('/audios/4.mp3');
      audio.play();
    }
    public static playAudioOutroMotivos() {
      var audio = new Audio('/audios/5.mp3');
      audio.play();
    }
    public static playAudioEncontrado() {
      var audio = new Audio('/audios/6.mp3');
      audio.play();
    }
    public static obterInteiroDaString(str: string): number {
      return parseInt(str.replace(/[^0-9]/gi, ''));
    }

    public static obterIncrementoValorFiltro(t: any): any {
      var i = this.pricesTiers.find((obj: any) => {
        return t >= obj.min;
      });

      return i.inc;
    }

    public static tratarValorDeFiltro(t: any): any {
      var i = this.pricesTiers.find((obj: any) => {
        return t >= obj.min;
      });

      return Math.round(t / i.inc) * i.inc;
    }
    public static incrementarValorNumerico(valor: number): number {
      return valor += 1;
    }

    public static decrementarValorNumerico(valor: number): any {
      return valor -= 1;
    }
    public static incrementarValorDeFiltro(t: any): any {
      if (t >= this.auctionMaxBid) {
        return this.auctionMaxBid
      };

      var e = this.pricesTiers.find((obj: any) => {
        return t >= obj.min;
      });

      return t + e.inc < this.auctionMaxBid ? Math.round((t + e.inc) / e.inc) * e.inc : this.auctionMaxBid;
    }

    public static decrementarValorDeFiltro(t: any): any {
      if (t <= 0) {
        return 0;
      }

      var e = this.pricesTiers.find((obj: any) => {
        return t > obj.min;
      });
      return 0 < t - e.inc ? Math.round((t - e.inc) / e.inc) * e.inc : 0;
    }

    public static obterSomenteNumerosDaString(str: string): any {
      return str.replace(/[^0-9]/g, '');
    }

    public static obterLimiteVariacaoFiltroPorValorCompra(valor: number): any {
      if (valor <= 1000) {
        return 400;
      } else if (valor <= 5000) {
        return 500;
      } else if (valor <= 10000) {
        return 900;
      } else if (valor <= 20000) {
        return 1200;
      } else if (valor <= 50000) {
        return 1800;
      } else if (valor <= 100000) {
        return 2500;
      } else {
        return 2900;
      }
    }

    public static getRandomInt(min: number, max: number) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    public async esperar(milliseconds: number) {
      return new Promise((resolve: any) => setTimeout(resolve, milliseconds));
    }

    public static sleep(milliseconds: number) {
      var start = new Date().getTime();
      for (var i = 0; i < 1e7; i++) {
        if ((new Date().getTime() - start) > milliseconds) {
          break;
        }
      }
    }

    public static redirecionarNaoAutenticado(urlAutenticado: string, urlRedirecionar: string) {
      $.get(urlAutenticado)
        .done((dados, status, jqXHR) => {
          if (!dados.autenticado) {
            window.location.href = urlRedirecionar;
            return;
          }
        });
    }

    public static tratarExibicaoLimiteComprasDiarias(limiteComprasDiarias: number, naoValidarPlano: boolean): string | number {
      if (naoValidarPlano) {
        return 'Ilimitado';
      }
      switch (limiteComprasDiarias) {
        case 9000000000000:
          return 'Ilimitado';
        default:
          return limiteComprasDiarias;

      }
    }

    public static isset(accessor: any) {
      try {
        return typeof accessor !== 'undefined';
      } catch (e) {
        return false;
      }
    }

    public static sortByMaxb(a: any, b: any) {
      return ((a.maxb < b.maxb) ? -1 : ((a.maxb > b.maxb) ? 1 : 0));
    }

    public static sortByBuyNowPrice(a: any, b: any) {
      return ((a.buyNowPrice < b.buyNowPrice) ? -1 : ((a.buyNowPrice > b.buyNowPrice) ? 1 : 0));
    }
    public static getIndiceArrayByAssetId(array: any, assetId: number | string) {
      var index = array.map(function (item: any) { return item.assetId; }).indexOf(assetId);
      return index;
    }
    public static getIndiceArrayById(array: any, id: number | string) {
      var index = array.map(function (item: any) { return item.id; }).indexOf(id);
      return index;
    }

    public static getItemArrayByAssetId(array: any, assetId: any) {
      var index = array.map(function (item: any) { return parseInt(item.assetId); }).indexOf(parseInt(assetId));
      return array[index];
    }

    public static getItemArrayByCustomId(array: any, id: number | string, keyId: string = "id", objDefault: any = null) {
      if (!$.isArray(array)) {
        if (objDefault) {
          return objDefault;
        }
        return;
      }
      var index = array.map(function (item: any) { return item && item.id ? item[keyId].toString() : null; }).indexOf(id.toString());
      if (index < 0 && objDefault) {
        return objDefault;
      }
      return array[index];
    }

    public static getItemArrayById(array: any, id: number | string, objDefault: any = null) {
      if (!$.isArray(array)) {
        if (objDefault) {
          return objDefault;
        }
        return;
      }
      var index = array.map(function (item: any) { return item.id ? item.id.toString() : null; }).indexOf(id.toString());
      if (index < 0 && objDefault) {
        return objDefault;
      }
      return array[index];
    }

    public static updateOrCreateItemArrayCustomId(array: any, id: number | string, objUpdate: any = null, keyId: string = "id", objDefault: any = null) {
      if (!$.isArray(array)) {
        if (objDefault) {
          return objDefault;
        }
        return;
      }
      var index = array.map(function (item: any) { return item[keyId].toString(); }).indexOf(id.toString());
      if (index >= 0) {
        array[index] = objUpdate;
      } else {
        array.push(objUpdate);
      }
      return array;
    }
    public static updateOrCreateItemArrayAssetId(array: any, assetId: number | string, objUpdate: any = null) {
      var index = array.map(function (item: any) { return item.assetId.toString(); }).indexOf(assetId.toString());
      if (index >= 0) {
        array[index] = objUpdate;
      } else {
        array.push(objUpdate);
      }
      return array;
    }

    public static updateItemArrayById(array: any, itemAtualizado: any, prop: any = null, valorUpdate: any = null, addSeNaoExistir: boolean = true) {
      var index = array.map(function (item: any) { return item.id.toString(); }).indexOf(itemAtualizado.id.toString());
      if (index >= 0) {
        array[index][prop] = valorUpdate;
      } else if (addSeNaoExistir) {
        array.push(itemAtualizado)
      }
      return array;
    }

    public static updateOrCreateItemArrayById(array: any, id: number | string, objUpdate: any = null) {
      var index = array.map(function (item: any) { return item.id.toString(); }).indexOf(id.toString());
      if (index >= 0) {
        array[index] = objUpdate;
      } else {
        array.push(objUpdate);
      }
      return array;
    }

    public static updateOrCreateItemArrayByEmail(array: any, email: number | string, objUpdate: any = null) {
      var index = array.map(function (item: any) { return item.email ? item.email.toString() : null; }).indexOf(email ? email.toString() : null);
      if (index >= 0) {
        array[index] = objUpdate;
      } else {
        array.push(objUpdate);
      }
      return array;
    }

    public static existeItemArrayById(array: any, id: number | string) {
      var index = array.map(function (item: any) {
        return item.id;
      }).indexOf(id);
      return index > -1;
    }

    public static listObjectToArray(obj: any) {
      var arr: any = [];
      for (var key in obj) {
        arr.push(obj[key]);
      }
      return arr;
    }

    public static getItemArrayByType(array: any, type: number | string) {
      var index = array.map(function (item: any) { return item.type; }).indexOf(type);
      return array[index];
    }

    public static arrayRemove(arr: any, value: string) {
      return arr.filter(function (ele: any) {
        return ele != value;
      });
    }
    public static arrayRemoveByResourceId(arr: any, value: string) {
      return arr.filter(function (ele: any) {
        return ele.resourceId != value;
      });
    }
    public static arrayExistByResourceId(arr: any, value: string | number) {
      return arr.filter(function (ele: any) {
        return ele.resourceId == value;
      }).length > 0;
    }

    public static getItemArraySeExistResourceId(array: any, resourceId: number | string) {
      var index = array.map(function (item: any) { return item.resourceId; }).indexOf(resourceId);
      return index >= 0 ? array[index] : false;
    }

    public static getIndiceArrayByResourceId(array: any, resourceId: number | string) {
      var index = array.map(function (item: any) { return item.resourceId; }).indexOf(resourceId);
      return index;
    }
    public static setArrayStorage(key: string, arr: any) {
      localStorage.setItem(key, JSON.stringify(arr));
    }

    public static safeStringify(obj: any, indent: number = 2) {
      let cache: any = [];
      const retVal = JSON.stringify(
        obj,
        (key, value) =>
          typeof value === "object" && value !== null
            ? cache.includes(value)
              ? undefined // Duplicate reference found, discard key
              : cache.push(value) && value // Store value in our collection
            : value,
        indent
      );
      cache = null;
      return retVal;
    };

    public static getArrayStorage(key: string) {
      var storedArray = localStorage.getItem(key);
      if (this.empty(storedArray)) {
        return null;
      } else {
        return JSON.parse(storedArray);
      }
    }
    public static exibirMensagemAlertaSwalPadrao(title: string, mensagem: string, tipo: string = "error", confirmButtonText: string = "OK", cancelButtonText: string = "Fechar", confirmButtonColor: string = "#FB6340", showCancelButton: boolean = true, urlRedirectClickConfirm: string = null, footer: string = null, contaEaJaVinculada: any = null) {
      var objSwal: any = {
        title: title,
        html: mensagem,
        type: tipo,
        confirmButtonText: confirmButtonText,
        confirmButtonColor: confirmButtonColor,
        showCancelButton: showCancelButton,
        cancelButtonText: cancelButtonText
      }
      if (footer) {
        objSwal.footer = footer;
      }
      swal(objSwal).then((result: any) => {
        if (result.hasOwnProperty('value') && result.value && urlRedirectClickConfirm) {
          window.location.href = urlRedirectClickConfirm;
          return;
        }

      });
    }

    public static existeIndexDataTable(dt: any, index: number) {
      return dt.rows().count() > index;
    }

    public static alterarLoadingProcessamento(elLoading: JQuery, porcentagem: any) {
      var corpoPorcentagem = elLoading.find('.corpo');
      corpoPorcentagem.removeClass('p' + corpoPorcentagem.data('porcentagem'));
      corpoPorcentagem.data('porcentagem', porcentagem);
      corpoPorcentagem.attr('data-porcentagem', porcentagem);
      corpoPorcentagem.addClass('p' + porcentagem);
      corpoPorcentagem.find('.porcentagem').html(porcentagem + '%');
    }

    public static exibirLoadingProcessamento(elLoading: JQuery, porcentagem: any) {
      var corpoPorcentagem = elLoading.find('.corpo');
      corpoPorcentagem.removeClass('p' + corpoPorcentagem.data('porcentagem'));
      corpoPorcentagem.data('porcentagem', porcentagem);
      corpoPorcentagem.attr('data-porcentagem', porcentagem);
      corpoPorcentagem.addClass('p' + porcentagem);
      corpoPorcentagem.find('.porcentagem').html(porcentagem + '%');
      elLoading.show();
    }

    public static ocultarLoadingProcessamento(elLoading: JQuery) {
      var corpoPorcentagem = elLoading.find('.corpo');
      corpoPorcentagem.removeClass('p' + corpoPorcentagem.data('porcentagem'));
      corpoPorcentagem.data('porcentagem', 0);
      corpoPorcentagem.attr('data-porcentagem', 0);
      corpoPorcentagem.addClass('p' + 0);
      corpoPorcentagem.find('.porcentagem').html(0 + '%');
      elLoading.hide();
    }

    public static marcarNotificacaoComoLida(e: JQueryEventObject): void {
      var ajax = new App.Ajax();
      var dados: any = { id: $(e.currentTarget).data('idNotificacao') };
      ajax.postAcaoSemResposta($(e.currentTarget).data('urlNotificacao'), dados);
    }
    public static stringParseJsonObject(str: string): any {
      var newJson = str.replace(/([a-zA-Z0-9]+?):/g, '"$1":');
      newJson = newJson.replace(/'/g, '"');
      return JSON.parse(newJson);
    }

    public static existeElementoNaPagina(el: JQuery): any {
      return el.length > 0;
    }

    public static getNomePlataforma(ptf: string) {
      switch (ptf) {
        case "psn":
        case "PSN":
        case "PS4":
        case "ps4":
          return "ps4"
        case "XBOX_ONE":
        case "xbox_one":
        case "xbox":
        case "xbo":
        case "XBL":
        case "xbl":
          return "xbox"
        case "pc":
          return "pc"
        default:
          return ptf;
      }
    }
    public static botaoProcessando(btn: JQuery, processando: boolean) {
      btn.prop("disabled", processando);
      if (processando) {
        btn.html(btn.html() + '&nbsp;<i class="fa fa-spinner fa-spin"></i>');
      } else {
        btn.html(btn.html().replace('&nbsp;<i class="fa fa-spinner fa-spin"></i>', ''));
      }
    }

    public static obterStatusItemNaListaDesc(obj: IItemListagem): string {
      switch (obj.statusListagem) {
        case "busca":
          return 'Buscando Preço...';
      }

      switch (obj.tradeState) {
        case "expired":
          return 'Venda Expirada';
        case "inactive":
          return 'Inativo';
        case "active":
          if (obj.bidState == "none") {
            return 'Venda Ativa';
          } else {
            return 'Lance Ativo';
          }
        case "closed":
          if (obj.bidState == "outbid") {
            return 'Lance Perdido';
          }
          if (obj.bidState == "highest") {
            return 'Lance Ganho';
          }
          if (obj.bidState == "none" && obj.state == "invalid") {
            return 'Vendido';
          }
      }

      if (obj.untradeable) {
        return 'Inegociável';
      }
    }
    public static obterStatusItemNaLista(obj: IItemListagem): string {
      switch (obj.statusListagem) {
        case "busca":
          return '<span class="badge badge-pill badge-buscando-preco text-uppercase">Buscando Preço...</span>';
      }

      switch (obj.tradeState) {
        case "expired":
          return '<span class="badge badge-pill badge-danger text-uppercase">Venda Expirada</span>';
        case "inactive":
          return '<span class="badge badge-pill badge-primary text-uppercase">Inativo</span>';
        case "active":
          if (obj.bidState == "none") {
            return '<span class="badge badge-pill badge-info text-uppercase">Venda Ativa</span>';
          } else {
            return '<span class="badge badge-pill badge-info text-uppercase">Lance Ativo</span>';
          }
        case "closed":
          if (obj.bidState == "outbid") {
            return '<span class="badge badge-pill badge-danger text-uppercase">Lance Perdido</span>';
          }
          if (obj.bidState == "highest") {
            return '<span class="badge badge-pill badge-success badge-lance-ganho text-uppercase">Lance Ganho</span>';
          }
          if (obj.bidState == "none" && obj.state == "invalid") {
            return '<span class="badge badge-pill badge-success badge-lance-ganho text-uppercase">Vendido</span>';
          }
      }

      if (obj.untradeable) {
        return '<span class="badge badge-pill badge-inegociavel text-uppercase">Inegociável</span>';
      }
    }

    public static getRowsDataTableByPropriedadeObjeto(datatableLista: any, propObj: string, valor: any) {
      let rowsResult = datatableLista.rows((idx: any, data: any, node: any) => {
        return data[propObj] == valor ?
          true : false;
      }).data();
      return rowsResult;
    }
    public static existeRowsDataTableByPropriedadeObjeto(datatableLista: any, propObj: string, valor: any) {
      let rowsResult = datatableLista.rows((idx: any, data: any, node: any) => {
        return data[propObj] == valor ?
          true : false;
      }).data();
      return rowsResult.length > 0;
    }
    public static getMinutosPassadosPartirDaDataInicial(startTime: any, endTime: any) {
      var difference = endTime.getTime() - startTime.getTime();
      return Math.round(difference / 60000);
    }

    public static ehItemVendaPermitida(item: IItemListagem) {
      return !item.untradeable && (item.tradeState === "expired" || item.tradeState === "inactive" || (item.tradeState === "closed" && item.bidState === "highest"));
    }
    public static filterPropObjByContainsString(obj: any, contains: string) {
      var filtros: any = [];
      $.each(Object.keys(obj), (index: number, value: any) => {
        if (value.includes(contains)) {
          filtros.push(obj[value]);
        }
      });
      return filtros;
    }
    public static getObjStatusViewLog(dadosLog: IDataLog): IStatusContaView {
      switch (dadosLog.tipo) {
        case Util.EVENTO_TIPO_COMPRA:
          if (dadosLog.status) {
            return { class: 'success', texto: 'Comprou' };
          }
          return { class: 'secondary', texto: 'Disputa perdida' };
        case Util.EVENTO_TIPO_ENVIOU_TRANSFERENCIA:
          if (dadosLog.status) {
            return { class: 'info', texto: 'Movido para Transferência' };
          }
        case Util.EVENTO_INICIOU_SNIPER:
          return { class: 'primary', texto: 'Iniciou Tarefa' };
        case Util.EVENTO_PAROU_SNIPER:
          return { class: 'primary', texto: 'Parou Tarefa' };
        case Util.EVENTO_PAROU_SNIPER_LIMITE_ATINGIDO:
          return { class: 'danger', texto: 'Limite de compra atingido' };
        case Util.EVENTO_LIMITE_VENDA_ATIVA_ATINGIDO:
          return { class: 'danger', texto: 'Limite venda ativa atingido' };
        case Util.EVENTO_SALDO_INSUFICIENTE_PARA_O_FILTRO:
          var dadosLogSaldo: { saldo: number, alterado: boolean, quantidadeFiltrosAtuais: number, conferencia: boolean, nome: string } = Util.getObjResponseLog(dadosLog);
          if (dadosLogSaldo.alterado) {
            return { class: 'filtro', texto: 'Preço Compra Alterado' };
          }
          return { class: 'amarelo', texto: 'Sem Saldo Para Filtro' };
        case Util.EVENTO_PAROU_CAPACIDADE_LISTAS_ATINGIDA:
          return { class: 'danger', texto: 'Lista cheia' };
        case Util.EVENTO_TIPO_COLOCOU_A_VENDA:
          return { class: 'info', texto: 'Colocou à venda' };
        case Util.EVENTO_TIPO_ERRO:
          return { class: 'danger', texto: 'Erro Indefinido' };
        case Util.EVENTO_TIPO_ENVIOU_CLUBE:
          return { class: 'info', texto: 'Enviou para o clube' };
        case Util.EVENTO_TIPO_RELISTOU:
          return { class: 'info', texto: 'Itens foram relistados à venda' };
        case Util.EVENTO_TIPO_LIMPAR_VENDIDOS:
          return { class: 'info', texto: 'Limpou itens vendidos' };
        case Util.EVENTO_TIPO_LISTA_NAO_ATRIBUIDOS_CHEIA:
          return { class: 'danger', texto: 'Lista de não atribuídos cheia' };
        case Util.EVENTO_TIPO_CAPTCHA:
          return { class: 'warning', texto: 'Captcha solicitado' };
        case Util.EVENTO_TIPO_SOFTBAN:
          return { class: 'warning', texto: 'Softban na conta' };
        case Util.EVENTO_TIPO_ERROS_EM_SEQUENCIA:
          return { class: 'warning', texto: 'Erro de conexão' };
        case Util.EVENTO_TIPO_INCIANDO_AUTOCAPTCHA:
          return { class: 'primary', texto: 'Iniciando AutoCaptcha' };
        case Util.EVENTO_TIPO_AUTOCAPTCHA_RESOLVIDO:
          return { class: 'success', texto: 'Captcha Resolvido' };
        case Util.EVENTO_TIPO_AUTOCAPTCHA_NAO_RESOLVIDO:
          return { class: 'danger', texto: 'Captcha Não Resolvido' };
        case Util.EVENTO_TIPO_LUCRO_INCOMPATIVEL_COM_FILTRO:
          return { class: 'warning', texto: 'Lucro Incompatível' };
        case Util.EVENTO_TIPO_LUCRO_FILTRO_BAIXO:
          return { class: 'warning', texto: 'Lucro Baixo' };
        case Util.EVENTO_TIPO_LUCRO_FILTRO_INUTIL:
          return { class: 'danger', texto: 'Lucro impossível' };
        case Util.EVENTO_TIPO_LUCRO_FILTRO_ESTIMADO:
          return { class: 'success', texto: 'Lucro Estimado' };
        case Util.EVENTO_TIPO_NENHUM_FILTRO_ENCONTRADO_PARA_TAREFA:
          return { class: 'amarelo', texto: 'Filtro nao encontrado' };
        case Util.EVENTO_ERROR_INICIAR_INSTANCIA:
          return { class: 'danger', texto: 'Erro ao abrir conta' };
        case Util.EVENTO_ERROR_INICIAR_INSTANCIA_COM_PROXY:
          return { class: 'danger', texto: 'Erro proxy' };
        case Util.EVENTO_ERROR_CONTA_NAO_HABILITADA_PARA_AGENDAMENTO:
          return { class: 'danger', texto: 'Conta não agendada' };
        case Util.EVENTO_TIPO_SALDO_INSUFICIENTE:
          return { class: 'danger', texto: 'Saldo insuficiente' };
        case Util.EVENTO_TIPO_VENDA_BLOQUEADA:
          return { class: 'info', texto: 'Venda bloqueada' };
        case Util.EVENTO_VENDA_COINS_EXECUTADA:
          return { class: 'primary', texto: 'Venda de coins executada' };
        case Util.EVENTO_TIPO_VENDA_NAO_INFORMADA:
          return { class: 'info', texto: 'Preço venda não encontrado' };
        case Util.EVENTO_TIPO_CONTA_CARREGADA:
          return { class: 'primary', texto: 'WebApp Recarregado' };
        case Util.EVENTO_TIPO_TRAVA_CONFERENCIA_FILTRO:
          return { class: 'amarelo-vermelho', texto: 'Conferência de Filtro' };
        case Util.EVENTO_TIPO_ATUALIZACAO_PRECO_COMPRA_FILTRO_LUCRO:
          return { class: 'primary', texto: 'Preço Compra Atualizado' };
        case Util.EVENTO_REVENDA_ITENS_TRANSFERENCIA_COINS:
          if (dadosLog.status) {
            return { class: 'info', texto: 'Iniciou Revenda' };
          }
          return { class: 'secondary', texto: 'Terminou Revenda' };
        case Util.EVENTO_REVENDA_ITEM_REVENDIDO:
          return { class: 'info', texto: 'Item de Revenda Listado' };
        case Util.EVENTO_RELISTAGEM:
          return { class: 'info', texto: 'Relistagem' };
        case Util.EVENTO_RELISTAGEM_DESCARTE:
          return { class: 'amarelo-second', texto: 'Descarte' };
        case Util.EVENTO_CONTA_ABERTA_COM_RESOLVER_BUG_EA:
          return { class: 'amarelo-second', texto: 'Resolver bug EA' };
        case Util.EVENTO_TRAVA_SEGURANCA:
          return { class: 'danger', texto: 'Sniper Interrompido' };
        case Util.EVENTO_LIMITE_ATINGIDO:
          return { class: 'danger', texto: 'Limite Atingido' };
        case Util.EVENTO_MOVE_CEMITERIO_TO_TRANSFER:
          return { class: 'info', texto: 'Movido Cemitério > Transferência' };
        case Util.EVENTO_VENDA_COINS_INICIADA:
          return { class: 'primary', texto: 'Venda Coins Iniciada' };
        case Util.EVENTO_VENDA_COINS_INCOMPLETA:
          return { class: 'warning', texto: 'Venda Coins Incompleta' };
        case Util.EVENTO_VENDA_COINS_ITEM_NAO_ENCONTRADO:
          return { class: 'primary', texto: 'Venda Coins: item não encontrado' };
        case Util.EVENTO_VENDA_COINS_ITEM_IGNORADO_POR_SEGURANCA:
          return { class: 'primary', texto: 'Venda Coins: item ignorado por segurança' };
        case Util.EVENTO_AUTENTICACAO_NAO_AUTORIZADA:
          return { class: 'danger', texto: 'Autenticação não autorizada' };
        case Util.EVENTO_AUTENTICACAO_NAO_AUTORIZADA_TROCA_PERSONA:
          return { class: 'danger', texto: 'Autenticação com persona não autorizada' };
        case Util.EVENTO_PERSONA_SELECIONADA:
          return { class: 'amarelo', texto: 'Persona Selecionada' };
        case Util.EVENTO_CARREGAMENTO_INCOMPLETO:
          return { class: 'danger', texto: 'Carregamento Incompleto' };
        case Util.EVENTO_PREVIA_PACOTE:
          return { class: 'previa', texto: 'Prévia pacote' };
        case Util.EVENTO_NAVEGADOR_ABRIU:
          return { class: 'primary', texto: 'Navegador Abriu' };
        case Util.EVENTO_NAVEGADOR_FECHOU:
          return { class: 'primary', texto: 'Navegador Fechou' };
        case Util.EVENTO_NAVEGADOR_INICIOU_WEBAPP:
          return { class: 'primary', texto: 'Abrindo WebApp' };
        case Util.EVENTO_LOGIN_INVALIDO:
          return { class: 'amarelo-second', texto: 'Login Inválido' };
        case Util.EVENTO_WEBAPP_COMPLETOU_CARREGAMENTO:
          return { class: 'primary', texto: 'WebApp Aberto' };

        case Util.EVENTO_CONTA_PERFIL_DEFAULT:
          return { class: 'amarelo-second', texto: 'Perfil Padrão utilizado' };
        case Util.EVENTO_CONTA_FILTROS_NAO_ATUALIZADOS:
          return { class: 'amarelo-second', texto: 'Filtros não atualizados' };
        case Util.EVENTO_ERRO_SINCRONIZAR_CONTA_LOCAL:
          return { class: 'amarelo-second', texto: 'Sincronização falhou' };
        case Util.EVENTO_ERRO_LIMPAR_CACHE_CONTA:
          return { class: 'amarelo-second', texto: 'Limpeza de cache falhou' };
        case Util.EVENTO_INSTALACAO_CHROME:
          if (dadosLog.status as any == "1") {
            return { class: 'amarelo-second', texto: 'Instalação Chrome' };
          }
          if (dadosLog.status as any == "2") {
            return { class: 'success', texto: 'Instalação Chrome' };
          }
          if (dadosLog.status as any == "3") {
            return { class: 'danger', texto: 'Erro Instalação Chrome' };
          }
        case Util.EVENTO_BROWSERS_LIMITE_EXCEDIDO:
          return { class: 'amarelo-second', texto: 'Limite servidor atingido' };
        case Util.EVENTO_CONTA_BANIDA_IDENTIFICADA_COM_MERCADO:
          return { class: 'verde-second', texto: 'Mercado liberado!' };
        case Util.EVENTO_AUTODME_DME_NAO_ENCONTRADO:
        case Util.EVENTO_AUTODME_DME_RESOLVIDO:
        case Util.EVENTO_PACOTE_ANALISE:
        case Util.EVENTO_AUTODME_ACOES:
          var dadosLogAutoDme: { textoStatus: string, html: string } = Util.getObjResponseLog(dadosLog);
          return { class: 'cinza-escuro', texto: dadosLogAutoDme.textoStatus ? dadosLogAutoDme.textoStatus : 'Auto DME' };
        case Util.EVENTO_PACOTE_ABERTO:
          var dadosLogAutoDme: { textoStatus: string, html: string } = Util.getObjResponseLog(dadosLog);
          return { class: 'pacote-aberto', texto: dadosLogAutoDme.textoStatus ? dadosLogAutoDme.textoStatus : 'Pacote Aberto' };
        case Util.EVENTO_FILTROS_DEFINIDOS:
          return { class: 'filtro', texto: `Filtro Definido` };
        case Util.EVENTO_FILTRO_NAO_PASSOU_NA_CONFERENCIA:
          return { class: 'filtro', texto: `Conferência Filtro` };
        case Util.EVENTO_FILTRO_AJUSTE_DE_LIMITE:
          return { class: 'filtro', texto: `Limite de Filtro Ajustado` };
        case Util.EVENTO_ERRO_AUTENTICACAO:
          return { class: 'amarelo-second', texto: `Autenticação Expirou` };

      }
    }
    public static getObjInfoViewLog(objLog: IDataLog): string {
      switch (objLog.tipo) {
        case Util.EVENTO_TIPO_COMPRA:
          var itemPlayer: IItemListagem = Util.getObjResponseLog(objLog);

          try {
            if (Util.objPlayers && itemPlayer.assetId) {
              var player = App.Util.getItemArrayById(Util.objPlayers, itemPlayer.assetId, App.Util.objJogadorDefault);
              itemPlayer.name = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
            }
          } catch (e) {
            console.log("erro nome 1", e, itemPlayer)
          }
          var descFiltro = ``;
          var descTradeId = ``;

          try {
            if (itemPlayer.tradeId) {
              descFiltro = ` (TradeId:${itemPlayer.tradeId}) `
            }
          } catch (error) { }

          if (itemPlayer.id_filtro) {
            descFiltro = `<span style="color: #9723f9;padding: 2px 5px 2px 6px;font-weight: 800;background-color: #f4f4f4;border-radius: 4px;font-size: 8px;margin-left: 10px;"><i class="fas fa-filter mr-1"></i>${itemPlayer.nome_filtro}</span>`
          }

          if (objLog.status && objLog.data.response) {
            return 'Comprou <b>' + itemPlayer.name + '(' + itemPlayer.rating + ')</b> por <b>' + itemPlayer.buyNowPrice + '</b>' + descTradeId + descFiltro;
          }
          if (itemPlayer) {
            return '<b>' + itemPlayer.name + '(' + itemPlayer.rating + ')</b> por <b>' + itemPlayer.buyNowPrice + '</b>' + descTradeId + descFiltro;
          }
          return " - ";
        case Util.EVENTO_TIPO_COLOCOU_A_VENDA:
          var itemPlayer: IItemListagem = Util.getObjResponseLog(objLog);
          var dataRequestVenda: IRequestAddVenda = Util.getObjRequestLog(objLog);

          try {
            if (Util.objPlayers && itemPlayer.assetId) {
              var player = App.Util.getItemArrayById(Util.objPlayers, itemPlayer.assetId, App.Util.objJogadorDefault);
              itemPlayer.name = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
            }
          } catch (e) {
            console.log("erro nome", e, itemPlayer)
          }

          if (itemPlayer) {
            return '<b>' + itemPlayer.name + '(' + itemPlayer.rating + ')</b> colocado à venda por <b>' + dataRequestVenda.buyNowPrice + '</b>';
          }
          return " - ";
        case Util.EVENTO_TIPO_ERRO:
          var objError: IErroProcesso = Util.getObjResponseLog(objLog);
          if (objError) {
            console.log("OOO", objError.error);
            return `PROCESSO: ${objError.processo} | ERROR: ${objError.error}`;
          }
          return " - ";
        case Util.EVENTO_TIPO_ENVIOU_TRANSFERENCIA:
          return "Item enviado para transferência";
        case Util.EVENTO_TIPO_LUCRO_INCOMPATIVEL_COM_FILTRO:
          var dadosLucro: any = Util.getObjResponseLog(objLog);
          return `O lucro de <b>${dadosLucro.lucroInformado}%</b> não é compatível com o filtro nesse momento, portanto o sistema modificou o lucro para uma valor aproximado de <b>${parseInt(dadosLucro.novoLucro)}%</b>, <br />esse é o lucro máximo compatível nesse momento.`;
        case Util.EVENTO_REVENDA_ITENS_TRANSFERENCIA_COINS:
          var respRevenda: any = Util.getObjResponseLog(objLog);
          if (objLog.status) {
            return `Quantidade itens encontrados para revenda: <b>${respRevenda.quantidade}</b>`;
          }
          return ' - ';
        case Util.EVENTO_REVENDA_ITEM_REVENDIDO:
          var respRevenda: any = Util.getObjResponseLog(objLog);
          return `Item listado: <b>${respRevenda.id}</b>`;
        case Util.EVENTO_RELISTAGEM:
          return `Itens foram relistados na lista de transferência`;
        case Util.EVENTO_RELISTAGEM_DESCARTE:
          return `Itens descartados.${Util.getLogJogadoresDescarte(Util.getObjResponseLog(objLog))}`;
        case Util.EVENTO_CONTA_ABERTA_COM_RESOLVER_BUG_EA:
          return `Conta iniciada com a opção de resolver bug da EA ativada.`;
        case Util.EVENTO_SALDO_INSUFICIENTE_PARA_O_FILTRO:
          var respostaSaldoFiltro: { saldo: number, alterado: boolean, quantidadeFiltrosAtuais: number, conferencia: boolean, nome: string } = Util.getObjResponseLog(objLog);
          if (respostaSaldoFiltro.alterado) {
            return `O preço de compra do filtro <b>${respostaSaldoFiltro.nome}</b> foi alterado para se adequar ao saldo atual da conta. <br />Preço de Compra Usado: <b>${respostaSaldoFiltro.saldo}</b>, configuração ativa no perfil, <b>"Usar Saldo Total em Saldo Insuf. Filtro"</b>`;
          }
          return respostaSaldoFiltro.conferencia ? `Saldo insuficiente, o filtro <b>${respostaSaldoFiltro.nome}</b> foi removido da tarefa atual` : `Saldo insuficiente para usar o filtro <b>${respostaSaldoFiltro.nome}</b>, <br />se quiser usar o saldo atual da conta, ative a configuração no perfil, <b>"Usar Saldo Total em Saldo Insuf. Filtro"</b>`;
        case Util.EVENTO_TRAVA_SEGURANCA:
          return `Por segurança o sistema foi interrompido, muitas buscas foram feitas e causaram erros, verifique se o problema é um softban.`;
        case Util.EVENTO_LIMITE_ATINGIDO:
          var respostaLimiteAtingido: { id_conta: number, limite_atual: number, id_perfil: number, requests: number } = Util.getObjResponseLog(objLog);

          let msgPerfil = !respostaLimiteAtingido.id_perfil ?
            `Sua conta está sem um perfil, para continuar, <b>crie um perfil para a conta</b>, <br />coloque um limite acima do atual no <b>campo "Limite de Requests dia"</b>, <br />salve esse perfil e aplique-o na conta,`
            : ' Para continuar, <b>edite o perfil da conta</b>, coloque um limite acima do atual no campo "Limite de Requests dia", <br />salve o perfil'

          return `O limite diário de buscas da sua conta foi atingido: <b>Limite Atual(${respostaLimiteAtingido.limite_atual})</b>.<br />${msgPerfil} depois clique em "remover limites" no menu "mais opções" do dashboard.`;
        case Util.EVENTO_MOVE_CEMITERIO_TO_TRANSFER:
          return `Iten(s) negociáveis movidos do cemitério para transferência.`;
        case Util.EVENTO_VENDA_COINS_INICIADA:
          return `Processo de venda de coins foi iniciado.`;
        case Util.EVENTO_VENDA_COINS_INCOMPLETA:
          var dadosVendaApi: any = Util.getObjResponseLog(objLog);
          return `Informe ao desenvolvedor, verifique se o item ${dadosVendaApi && dadosVendaApi.item ? dadosVendaApi.item.id : ''} foi comprado e registrado na API, <br />se o item foi comprado provavelmente não será revendida automaticamente.`;
        case Util.EVENTO_VENDA_COINS_ITEM_NAO_ENCONTRADO:
          var dadosVendaApi: any = Util.getObjResponseLog(objLog);
          return `Item ${dadosVendaApi && dadosVendaApi.item ? dadosVendaApi.item.id : ''} informado pela API não foi encontrado.`;
        case Util.EVENTO_VENDA_COINS_ITEM_IGNORADO_POR_SEGURANCA:
          return `Para evitar banimentos o item informado pela API não pode ser comprado por essa conta específica, obedecendo as regras de segurança da API.`;
        case Util.EVENTO_TIPO_LUCRO_FILTRO_INUTIL:
          var dadosFiltroInutil: any = Util.getObjResponseLog(objLog);
          return dadosFiltroInutil && dadosFiltroInutil.filtro_nome ? `Filtro usado: ${dadosFiltroInutil.filtro_nome}` : ` - `;
        case Util.EVENTO_AUTENTICACAO_NAO_AUTORIZADA:
          return `Confira se a conta está logada em algum outro dispositivo ou se está impedida de logar.`;
        case Util.EVENTO_AUTENTICACAO_NAO_AUTORIZADA_TROCA_PERSONA:
          return `Confira se a conta escolhida está com a persona correta, se não usa persona em sua conta, escolha a opção de persona default nas configurações de credenciais.`;
        case Util.EVENTO_PERSONA_SELECIONADA:
          var dadosSelecaoPersona: { persona: string } = Util.getObjResponseLog(objLog);
          return `A persona ${dadosSelecaoPersona.persona} foi selecionada para esta conta. Caso não seja a persona correta, você pode ajusta-la nas opções "credenciais" da sua conta.`;
        case Util.EVENTO_CARREGAMENTO_INCOMPLETO:
          return `Se o problema continuar, abra a conta manualmente e verifique o motivo.`;
        case Util.EVENTO_LOGIN_INVALIDO:
          return `Uma tentativa de login falhou.`;
        case Util.EVENTO_TIPO_TRAVA_CONFERENCIA_FILTRO:
          var dadosConferenciaFiltro: { conferenciaFiltro: IConferenciaFiltro, filtroSelecionado: any } = Util.getObjResponseLog(objLog);
          // console.log("dadosConferenciaFiltroUtil", dadosConferenciaFiltro)
          return Util.getMensagemConferenciaFiltro(dadosConferenciaFiltro.conferenciaFiltro);
        case Util.EVENTO_PREVIA_PACOTE:
          var respostaPrevia: { mensagem: string, previaPacote: IPreviaPacote } = Util.getObjResponseLog(objLog);

          if ((!respostaPrevia || !respostaPrevia.mensagem || !respostaPrevia.previaPacote)) {
            return '-'
          }

          switch (parseInt(respostaPrevia.mensagem)) {
            case Util.ID_MENSAGEM_RESPOSTA_PREVIA_PACOTE_INICIADA:
              return `Verificando Prévia de Pacote.`;
            case Util.ID_MENSAGEM_RESPOSTA_PREVIA_PACOTE_SALDO_INSUFICIENTE:
              return `Saldo insuficiente para comprar a prévia de pacote. <b>Lucro Previsto: ${(respostaPrevia.previaPacote.lucro - respostaPrevia.previaPacote.precoPrevia)}</b>${this.getLogJogadoresPreviaPacote(respostaPrevia)}`;
            case Util.ID_MENSAGEM_RESPOSTA_PREVIA_PACOTE_ITENS_NAO_ATRIBUIDOS:
              return `Prévia de pacote(Com Lucro) <b>não comprada</b>, remova os itens do cemitério e compre a prévia manualmente. <b>Lucro Previsto: ${(respostaPrevia.previaPacote.lucro - respostaPrevia.previaPacote.precoPrevia)}</b>${this.getLogJogadoresPreviaPacote(respostaPrevia)}`;
            case Util.ID_MENSAGEM_RESPOSTA_PREVIA_PACOTE_COMPRADA:
              return `Prévia de pacote comprada. <b>Lucro Previsto: ${(respostaPrevia.previaPacote.lucro - respostaPrevia.previaPacote.precoPrevia)}</b>${this.getLogJogadoresPreviaPacote(respostaPrevia)}`;
            case Util.ID_MENSAGEM_RESPOSTA_PREVIA_PACOTE_ERROR:
              return `Um Erro ocorreu com a funcionalidade de prévia de pacote, desative a funcionalidade em seu perfil e informe ao desenvolvedor caso o erro continue.`;
          }

          return " - ";

        case Util.EVENTO_CONTA_PERFIL_DEFAULT:
          return `O perfil padrão de sistema foi utilizado para essa conta, se necessário, crie um perfil e aplique na conta.`;
        case Util.EVENTO_CONTA_FILTROS_NAO_ATUALIZADOS:
          return `Os filtros não foram atualizados, mas não se preocupe, uma nova tentativa de atualização será feita e os últimos filtros válidos utilizados estão sendo usados.`;
        case Util.EVENTO_ERRO_SINCRONIZAR_CONTA_LOCAL:
          return `Erro ao sincronizar a conta local, reinicie o plugin e tente novamente, se não funcionar, tente abrir a conta pelo sistema ou então adiciona-la novamente.`;
        case Util.EVENTO_ERRO_LIMPAR_CACHE_CONTA:
          return `Não foi possível limpar o cache da conta, reinicie o plugin e tente novamente.`;
        case Util.EVENTO_BROWSERS_LIMITE_EXCEDIDO:
          return `Você atingiu o número máximo de contas abertas ao mesmo tempo.`;
        case Util.EVENTO_CONTA_BANIDA_IDENTIFICADA_COM_MERCADO:
          return `A conta que anteriormente estava com status "sem mercado" foi agora identificada como "com mercado".`;
        case Util.EVENTO_INSTALACAO_CHROME:
          if (objLog.status as any == "1") {
            return `Plugin iniciou uma instalação do chrome.`;
          }
          if (objLog.status as any == "2") {
            return `Plugin terminou com sucesso a instalação do chrome.`;
          }
          if (objLog.status as any == "3") {
            return `Um erro ocorreu e o plugin não conseguiu instalar o chrome.`;
          }
        case Util.EVENTO_AUTODME_DME_NAO_ENCONTRADO:
        case Util.EVENTO_AUTODME_DME_RESOLVIDO:
        case Util.EVENTO_PACOTE_ANALISE:
        case Util.EVENTO_AUTODME_ACOES:
        case Util.EVENTO_PACOTE_ABERTO:
          var dadosLogAutoDme: { html: string } = Util.getObjResponseLog(objLog);
          console.log("DADOS LOG AUTO DME", dadosLogAutoDme)
          return dadosLogAutoDme.html;
        case Util.EVENTO_FILTROS_DEFINIDOS:
          let dadosFiltros: { nomeFiltroExecucao: string, nomeFiltrosDefinidos: string, evento: string, precoCompra: string, vaiVariarPrecoBusca: boolean } = Util.getObjResponseLog(objLog);
          let infoVariarPreco = dadosFiltros.vaiVariarPrecoBusca ? ' com variação' : '';
          let infoEvento = '';
          if (dadosFiltros.evento == "STARTED") {
            infoEvento = "no início da tarefa";
          } else if (dadosFiltros.evento == "RESUMED") {
            infoEvento = "na continuação da tarefa";
          }
          return `Filtro Definido: <b>${dadosFiltros.nomeFiltroExecucao}</b> ${infoEvento} | Preço de Compra: <b>${dadosFiltros.precoCompra}${infoVariarPreco}</b><br/>Filtros da tarefa: <b>${dadosFiltros.nomeFiltrosDefinidos}</b>`;
        case Util.EVENTO_FILTRO_NAO_PASSOU_NA_CONFERENCIA:
          let dadosFiltrosConferencia: { nome: string } = Util.getObjResponseLog(objLog);
          return `O filtro <b>${dadosFiltrosConferencia.nome}</b> não passou na conferência e foi removido da tarefa.<br/>Motivos possíveis: filtro com preço de compra desatualizado, com risco de prejuízo, saldo insuficiente, lucro incompatível.`;
        case Util.EVENTO_FILTRO_AJUSTE_DE_LIMITE:
          let dadosFiltrosLimite: { nome: string, limiteCompraMin: number, limiteCompraMax: number } = Util.getObjResponseLog(objLog);
          if (dadosFiltrosLimite.limiteCompraMin) {
            return `O preço de compra do filtro <b>${dadosFiltrosLimite.nome}</b> foi ajustado para o valor mínimo permitido de <b>${dadosFiltrosLimite.limiteCompraMin}</b>. <br />Essa é uma medida de segurança configurada no cadastro do filtro para evitar buscas desnecessárias.`;
          }

          if (dadosFiltrosLimite.limiteCompraMax) {
            return `O preço de compra do filtro <b>${dadosFiltrosLimite.nome}</b> foi ajustado para o valor máximo permitido de <b>${dadosFiltrosLimite.limiteCompraMax}</b>. <br />Essa é uma medida de segurança configurada no cadastro do filtro para evitar prejuízos.`;
          }

          return '';
        case Util.EVENTO_ERRO_AUTENTICACAO:
          let dadosErroAuth: { ignorar: boolean } = Util.getObjResponseLog(objLog);
          if (dadosErroAuth.ignorar) {
            return `Foi necessário ignorar o erro de autenticação para continuar o funcionamento da conta.<br />Uma nova autenticão é feita automaticamente pelo WebApp.`;
          }

          return `Foi necessário fechar a conta para fazer uma nova autenticação.`;
        default:
          return " - ";
      }
    }
    private static getLogJogadoresPreviaPacote(respostaPrevia: { mensagem: string, previaPacote: IPreviaPacote }): any {
      try {
        return `<br />${respostaPrevia.previaPacote.itensEmVenda.map(obj => `<b>${obj.item.itemData.name}(${obj.item.itemData.rating})</b> por <b>${obj.preco}</b>`).join(", ")}`;
      } catch (e) {
        console.log("erro log previa", e)
        return ``;
      }
    }

    public static getObjResponseLog(objLog: IDataLog): any {
      return objLog.data && objLog.data.response ? JSON.parse(objLog.data.response) : null;
    }

    private static getObjRequestLog(objLog: IDataLog): any {
      return objLog.data && objLog.data.request ? JSON.parse(objLog.data.request) : null
    }

    public static getObjStatusView(status: number): IStatusContaView {
      switch (status) {
        // case Util.STATUS_CONTA_NAO_AUTENTICADA:
        //     return { class: 'warning', texto: 'Not Authenticated' };
        // case Util.STATUS_CONTA_AUTENTICADA_DESLIGADA:
        //     return { class: 'secondary', texto: 'Authenticated:Off' };
        // case Util.STATUS_CONTA_AUTENTICADA_LIGADA:
        //     return { class: 'success', texto: 'Authenticated:On' };
        // case Util.STATUS_CONTA_EXECUTANDO:
        //     return { class: 'success', texto: 'Authenticated:Running' };
        // case Util.STATUS_CONTA_AUTENTICACAO_EXPIRADA:
        //     return { class: 'danger', texto: 'Expired Authentication' };
        // case Util.STATUS_CONTA_COM_CAPTCHA:
        //     return { class: 'danger', texto: 'Captcha required' };
        default:
          return { class: 'warning', texto: 'Not Authenticated' };
      }
    }


    public static getDescricaoHumanaMilissegundos(duration: number) {
      const portions: string[] = [];

      const msInHour = 1000 * 60 * 60;
      const hours = (Math as any).trunc(duration / msInHour);
      if (hours > 0) {
        portions.push(hours + 'h');
        duration = duration - (hours * msInHour);
      }

      const msInMinute = 1000 * 60;
      const minutes = (Math as any).trunc(duration / msInMinute);
      if (minutes > 0) {
        portions.push(minutes + 'm');
        duration = duration - (minutes * msInMinute);
      }

      const seconds = (Math as any).trunc(duration / 1000);
      if (seconds > 0) {
        portions.push(seconds + 's');
      }

      return portions.join(' ');
    }

    public static getDescFuncionamentoAtual(dadosFuncionamento: IFuncionamentoAtual) {
      return {
        velocidade: Util.parseMilisegundosParaSegundos(dadosFuncionamento.velocidade).toString() + " Seg",
        intervalo: Util.parseMilisegundosParaMinutos(dadosFuncionamento.intervalo).toString() + " Min",
        descanso: Util.parseMilisegundosParaSegundos(dadosFuncionamento.descanso).toString() + " Seg",
      }
    }

    public static efeitoBilhoFundo(elemento: JQuery, cor: string) {
      elemento.css({ 'transition': 'background-color 2s', 'background-color': cor });
      setTimeout(() => {
        elemento.css({ 'transition': 'background-color 2s', 'background-color': cor }).css({ 'transition': 'background-color 2s', 'background-color': 'transparent' })
      }, 2000)
    }

    //exe: horas > minutos || minutos > segundos etc...
    public static converterTempoParaTempoBaseAnterior(valor: any) {
      var final_result = null
      var num = parseFloat(valor);
      var convertido: any = num * 60;
      if (Math.round(convertido) !== convertido) {
        final_result = parseFloat(convertido.toFixed(10));
      } else {
        final_result = parseFloat(convertido);
      }

      return final_result % 1 != 0 ? final_result.toFixed(2) : final_result;
    }
    //exe: minutos > horas || segundos > minutos etc...
    public static converterTempoParaTempoBasePosterior(valor: any) {
      var final_result = null
      var num = parseFloat(valor);
      var convertido: any = num / 60;
      if (Math.round(convertido) !== convertido) {
        final_result = parseFloat(convertido.toFixed(10));
      } else {
        final_result = parseFloat(convertido);
      }

      return final_result % 1 != 0 ? final_result.toFixed(2) : final_result;
    }

    public static getOptionsSelectTag(): any {
      return {
        tags: true, width: '100%', createTag: function (params: any) {
          var valorDigitado: any = $.trim(params.term);
          if (valorDigitado === '' || !$.isNumeric(valorDigitado) || ($.isNumeric(valorDigitado) && valorDigitado <= 0)) {
            return null;
          }

          var elemento = this.$element;
          var condicao: { menor: { valor: number, sufix: string, multx: number }, maior: { valor: number, sufix: string, multx: number } } = Util.empty(elemento.data("condicao")) ? { menor: null, maior: null } : elemento.data("condicao")
          var id: any = valorDigitado
          var multx: any = elemento.data("multx")
          var sufix: any = elemento.data("sufixDesc")

          if (condicao.menor && valorDigitado < condicao.menor.valor) {
            multx = condicao.menor.multx
            sufix = condicao.menor.sufix
            valorDigitado = Util.converterTempoParaTempoBaseAnterior(id);
          }

          if (condicao.maior && valorDigitado >= condicao.maior.valor) {
            multx = condicao.maior.multx * 60
            sufix = condicao.maior.sufix
            valorDigitado = Util.converterTempoParaTempoBasePosterior(id);
          }

          console.log("AQUI", id, multx, sufix, condicao, condicao)

          var text: string = Util.empty(sufix) ? valorDigitado : valorDigitado + ` ${sufix}`
          try {
            id = !Util.empty(multx) && $.isNumeric(valorDigitado) && $.isNumeric(multx) ? valorDigitado * parseInt(multx) : valorDigitado
          } catch (e) {
            console.log("error", e)
            id = valorDigitado
          }

          return { id: id, text: text, newTag: true }
        }
      };
    }

    public static runAudio(idAudio: number = 1) {
      switch (idAudio) {
        case 1:
          App.Util.playAudioCompra();
          break;
        case 2:
          App.Util.playAudioParouCompra();
          break;
        case 3:
          App.Util.playAudioCaptcha();
          break;
        case 4:
          App.Util.playAudioGanhouLance();
          break;
        case 5:
          App.Util.playAudioOutroMotivos();
          break;
        case 6:
          App.Util.playAudioEncontrado();
          break;
      }

    }

    public static iniciarCronometro(objcronometro: any, element: JQuery, tempo: number) {
      if (!objcronometro) {
        objcronometro = new Timer();
      }
      objcronometro.start({ countdown: true, startValues: { seconds: tempo } });
      element.html(objcronometro.getTimeValues().toString());
      element.parents('.cronometro').show();
      objcronometro.addEventListener('secondsUpdated', (e: JQueryEventObject) => {
        element.html(objcronometro.getTimeValues().toString());
      });
      objcronometro.addEventListener('started', (e: JQueryEventObject) => {
        element.parents('.cronometro').show();
      });
      objcronometro.addEventListener('stopped', (e: JQueryEventObject) => {
        element.parents('.cronometro').hide();
        element.html('');
      });
      objcronometro.addEventListener('targetAchieved', (e: JQueryEventObject) => {
        element.parents('.cronometro').hide();
        element.html('');
      });
    }

    public static pararCronometro(objcronometro: any, element: JQuery = null) {
      try {
        if (objcronometro) {
          objcronometro.stop();
        }
        if (element) {
          element.parents('.cronometro').hide();
        }
      } catch (e) {
        console.log("cronometro nao encontrado", e)
      }
    }

    public static iniciarCronometroMult(cronometro: any, selector: string, seconds: number) {
      if (cronometro) {
        cronometro.stop()
        cronometro.reset()
        cronometro.start(seconds)
        return cronometro
      }
      // setup
      const $element = document.querySelector(selector);
      const timer = new Timer();

      // helpers
      const start = (seconds: number) => {
        if (seconds) {
          timer.start({ startValues: { seconds } });
        } else {
          timer.start();
        }
      };

      // init
      $element.innerHTML = timer.getTimeValues().toString();
      timer.addEventListener('secondsUpdated', function (e: any) {
        $element.innerHTML = timer.getTimeValues().toString();
      });

      // returns
      return {
        start,
        stop: timer.stop,
        pause: timer.pause,
        reset: timer.reset,
      };
    }

    public static pararCronometroMult(cronometro: any) {
      if (cronometro) {
        cronometro.stop()
      }
    }


    public static getModoheadless(el: JQuery = $("#abrirTelaWebapp")) {
      return el.length < 0 ? false : !el.is(":checked");
    }

    public static pinSidenav() {
      $('.sidenav-toggler').addClass('active');
      $('.sidenav-toggler').data('action', 'sidenav-unpin');
      $('body').removeClass('g-sidenav-hidden').addClass('g-sidenav-show g-sidenav-pinned');
      $('body').append('<div class="backdrop d-xl-none" data-action="sidenav-unpin" data-target=' + $('#sidenav-main').data('target') + ' />');
      Cookies.set('sidenav-state', 'pinned');
    }

    public static unpinSidenav() {
      $('.sidenav-toggler').removeClass('active');
      $('.sidenav-toggler').data('action', 'sidenav-pin');
      $('body').removeClass('g-sidenav-pinned').addClass('g-sidenav-hidden');
      $('body').find('.backdrop').remove();
      Cookies.set('sidenav-state', 'unpinned');
    }

    public static ehAppDesktop() {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(' electron/') != -1) {
        return true;
      }
      return false;
    }

    public static mergeObject(a?: any, b?: any) {
      var obj: any = {},
        i = 0,
        il = arguments.length,
        key;
      for (; i < il; i++) {
        for (key in arguments[i]) {
          if (arguments[i].hasOwnProperty(key)) {
            obj[key] = arguments[i][key];
          }
        }
      }
      return obj;
    }

    public static ehChromeConfigurado() {
      var countFalha = 0;
      try {
        if (SharedWorker) {
          countFalha--;
        }
      } catch (error) {
        countFalha++;
      }
      try {
        if (webkitSpeechRecognition) {
          countFalha--;
        }
      } catch (error) {
        countFalha++;
      }

      return countFalha == 2;
    }

    public static formatDuration(ms: number) {
      if (ms < 0) ms = -ms;
      const time = {
        day: Math.floor(ms / 86400000),
        hour: Math.floor(ms / 3600000) % 24,
        minute: Math.floor(ms / 60000) % 60,
        second: Math.floor(ms / 1000) % 60,
        millisecond: Math.floor(ms) % 1000
      };
      return (Object as any).entries(time)
        .filter((val: any) => val[1] !== 0)
        .map((val: any) => val[1] + ' ' + (val[1] !== 1 ? val[0] + 's' : val[0]))
        .join(', ');
    };

    public static exibirAlertaConfirmacaoSwal(objSwal: any, callback: any, versao: number = 1) {
      if (versao == 2) {
        if (objSwal.hasOwnProperty('type')) {
          objSwal.icon = objSwal.type;
        }

        swal.fire(objSwal).then((result: any) => {
          callback(result.isConfirmed)
        })
      } else {
        swal(objSwal).then((result: any) => {
          callback(result.value)
        })
      }
    }

    public static getRangeValuesNoUiSlider(elIputNoUiSlider: JQuery) {
      var valuesSlider = elIputNoUiSlider.data('arrayLabelsCustom')
      var arraySlider = App.Util.stringParseJsonObject(valuesSlider);
      var objSlider: any = {};
      var percent = 100 / arraySlider.length
      var qpercent = percent / 2
      $.each(arraySlider, (index: number, obj: any) => {
        let ehPrimeiroItem = index == 0;
        let ehUltimoItem = (arraySlider.length - 1) == index;

        if (ehPrimeiroItem) {
          objSlider.min = obj.value
        } else if (ehUltimoItem) {
          objSlider.max = obj.value
        } else {
          objSlider[`${percent + qpercent}%`] = obj.value
          percent += percent;
        }
      });
      return objSlider
    }
    public static salvarLogSniper(elementoLog: JQuery, classTipo: string, tituloLog: string, descricao: string) {
      elementoLog.prepend(`<span class="text-uppercase font-size-10 badge badge-pill ${classTipo}">${tituloLog}</span><span class="text-muted pull-right mt-1 font-size-10">` + new Date().toLocaleString() + `</span><p class="description border-bottom font-size-12">${descricao}</p>`);
    }

    public static atualizarIconeLoadingTentativasSniper(el: JQuery = $('.tentativas'), classe: string, info: string = '') {
      el.html('<i class="' + classe + '" title="' + info + '"></i>');
    }

    public static incrementarTentativa(el: JQuery = $('.tentativas'), exibirIcone: any = null) {
      if (exibirIcone) {
        this.atualizarIconeLoadingTentativasSniper(el, exibirIcone);
      } else {
        var tentativa = Util.obterInteiroDaString(el.html());
        el.html((($.isNumeric(tentativa) ? tentativa : 0) + 1).toString());
      }
    }

    public static reinicializarTentativas(el: JQuery = $('.tentativas')) {
      el.html('0')
    }

    public static incrementarComprasModalSniper(el: JQuery = $('.quantidade-compras-modal-sniper')) {
      var compras = Util.obterInteiroDaString(el.html());
      el.html((($.isNumeric(compras) ? compras : 0) + 1).toString());
    }

    public static reinicializarQuantidadeComprasModalSniper(el: JQuery = $('.quantidade-compras-modal-sniper')) {
      el.html('0')
    }

    public static validarFiltroSniper(dadosEnviados: IFormDadosSniperPro, ehConsumiveis: boolean = false) {
      if (dadosEnviados.piloto_automatico) {
        return true
      }

      let ehPorLucro = dadosEnviados.precoCompra == 2
      let campoJogadoresVazio = App.Util.empty(dadosEnviados.maskedDefId)


      if (App.Util.empty(dadosEnviados.quality) && App.Util.empty(dadosEnviados.rarity) && App.Util.empty(dadosEnviados.position) && App.Util.empty(dadosEnviados.chemical)
        && campoJogadoresVazio && App.Util.empty(dadosEnviados.club) && App.Util.empty(dadosEnviados.league) && App.Util.empty(dadosEnviados.nation)) {

        App.Util.exibirSweetAlertaFireSimples("Obrigatório!", "Informe pelo menos um filtro.", "error")
        return false;
      }

      if (ehPorLucro && App.Util.empty(dadosEnviados.lucro)) {
        App.Util.exibirSweetAlertaFireSimples("Obrigatório!", "Informe a porcentagem de lucro.", "error");
        return false;
      }

      if (!ehPorLucro && App.Util.empty(dadosEnviados.maxBuyNow)) {
        App.Util.exibirSweetAlertaFireSimples("Obrigatório!", "Informe o valor de compra.", "error");
        return false;
      }

      if (ehPorLucro && !campoJogadoresVazio && $.isArray(dadosEnviados.maskedDefId) && dadosEnviados.maskedDefId.length > 1) {
        App.Util.exibirSweetAlertaFireSimples("Obrigatório!", "No filtro por lucro por enquanto é permitido no máximo 1 jogador no campo de jogadores.", "error");
        return false;
      }

      return true;
    }

    public static getAllNamesFormBySeletor(form: any, seletor: string): string[] {
      let names: string[] = []
      $.each(form.find(seletor), function (index, elem) {
        names.push(elem.name)
      });
      return names
    }

    public static preencherFormulario(form: any, dadosForm: any) {
      let inputsCheckbox: any = Util.getAllNamesFormBySeletor(form, 'input[type=checkbox]')
      let inputsRadios: any = Util.getAllNamesFormBySeletor(form, 'input[type=radio]')
      let selects: any = Util.getAllNamesFormBySeletor(form, 'select')

      for (const [prop, valor] of (Object as any).entries(dadosForm)) {
        if (inputsCheckbox.includes(prop)) {
          form.find(`input[name=${prop}]`).prop("checked", valor);
        } else if (inputsRadios.includes(prop)) {
          form.find(`input[name=${prop}][value=${valor}]`).prop('checked', 'checked');
        } else if (selects.includes(prop)) {
          form.find(`select[name=${prop}]`).val(valor ? valor : "")
        } else {
          form.find(`input[name=${prop}]`).val(valor)
        }
      }
    }
    public static getStatusDescContaById(status: number): { class: string, status: string } {
      switch (status) {
        case Util.STATUS_CONTA_ABERTA:
          return { class: 'info', status: 'Aberta' };
        case Util.STATUS_CONTA_CAPTCHA:
          return { class: 'danger', status: 'Captcha Solicitado' };
        case Util.STATUS_CONTA_CAPTCHA_FALHA_AUTOCAPTCHA:
          return { class: 'danger', status: 'Captcha não Resolvido' };
        case Util.STATUS_CONTA_EXECUCAO:
          return { class: 'success', status: 'Executando' };
        case Util.STATUS_CONTA_NAO_AUTENTICADA:
          return { class: 'secondary', status: 'Não Autenticada' };
        case Util.STATUS_CONTA_PARADA:
          return { class: 'secondary', status: 'Parada' };
        case Util.STATUS_CONTA_VENDENDO_COINS:
          return { class: 'primary', status: 'Vendendo Coins' };
        case Util.STATUS_CONTA_BANIDA:
          return { class: 'danger badge-sem-mercado', status: 'Sem Mercado' };
        case Util.STATUS_POSSIVEL_SOFTBAN_BUSCA:
        case Util.STATUS_POSSIVEL_SOFTBAN_COMPRA:
        case Util.STATUS_POSSIVEL_SOFTBAN_ALTERNATIVO_1:
        case Util.STATUS_POSSIVEL_SOFTBAN_ALTERNATIVO_2:
          return { class: 'danger', status: 'Softban' };
        default:
          return { class: 'secondary', status: ' - ' };
      }
    }

    public static getSortByStatusConta(status: number) {
      switch (status) {
        case Util.STATUS_CONTA_EXECUCAO:
          return 1;
        case Util.STATUS_CONTA_VENDENDO_COINS:
          return 2;
        case Util.STATUS_CONTA_ABERTA:
          return 3;
        case Util.STATUS_CONTA_CAPTCHA:
        case Util.STATUS_CONTA_CAPTCHA_FALHA_AUTOCAPTCHA:
          return 4;
        case Util.STATUS_CONTA_PARADA:
          return 5;
        case Util.STATUS_POSSIVEL_SOFTBAN_BUSCA:
        case Util.STATUS_POSSIVEL_SOFTBAN_COMPRA:
        case Util.STATUS_POSSIVEL_SOFTBAN_ALTERNATIVO_1:
        case Util.STATUS_POSSIVEL_SOFTBAN_ALTERNATIVO_2:
          return 6;
        case Util.STATUS_CONTA_BANIDA:
          return 7;
        default:
          return 8;
      }
    }

    public static getNomeOuIdConta(conta: IConta) {
      if (!conta && !conta.id) {
        return '';
      }

      return conta && conta.dadosEa && conta.dadosEa.clubeName ? conta.dadosEa.clubeName : conta.id
    }

    public static limparEstatisticas(chave: string) {
      let limit = 7;
      let estatisticas: any = JSON.parse(localStorage.getItem(chave)) || null;
      if (!estatisticas) {
        return
      }
      let estatisticasSave: any = {};

      for (const index of Object.keys(estatisticas).reverse()) {
        if (Object.keys(estatisticasSave).length < limit) {
          estatisticasSave[index] = estatisticas[index];
        }
      }

      estatisticas = {};
      for (const index of Object.keys(estatisticasSave).reverse()) {
        estatisticas[index] = estatisticasSave[index];
      }

      localStorage.setItem(chave, JSON.stringify(estatisticas));
    }

    public static getEstatisticasDoDia(chave: string) {
      let estatisticas: any = {};
      let keyDataDia = App.Util.getDateStringInternacional();

      try {
        estatisticas = JSON.parse(localStorage.getItem(chave)) || {};
      } catch (er) {
        estatisticas[keyDataDia] = {}
      }

      if (!estatisticas) {
        estatisticas[keyDataDia] = {}
      }

      return estatisticas[keyDataDia];
    }

    public static incrementEstatisticas(chave: string, counterName: string, valueIncrement: number = 1) {
      let estatisticas: any = {};
      let keyDataDia = App.Util.getDateStringInternacional()

      try {
        estatisticas = JSON.parse(localStorage.getItem(chave)) || {};
      } catch (er) {
        estatisticas = {};
      }

      if (!estatisticas[keyDataDia]) {
        estatisticas[keyDataDia] = {}
      }

      if (typeof estatisticas[keyDataDia][counterName] !== 'number') {
        estatisticas[keyDataDia][counterName] = 0;
      }

      estatisticas[keyDataDia][counterName] += valueIncrement;

      localStorage.setItem(chave, JSON.stringify(estatisticas));

      return estatisticas[keyDataDia][counterName];
    }

    public static getSecondsBetweenDates(startDate: any, endDate: any): any {
      var diff = endDate.getTime() - startDate.getTime();
      return (diff / 1000);
    }
    public static getDateStringInternacional(): any {
      return new Date().toISOString().slice(0, 10);
    }
    public static parseDataUtcStringToDateLocale(strDateUtc: string): any {
      return new Date(`${strDateUtc} UTC`).toLocaleString()
    }
    public static parseDataStringToDateLocale(strDateUtc: string): any {
      return new Date(`${strDateUtc}`).toLocaleString()
    }
    public static getDateStringDefault(): any {
      return new Date().toISOString().split('T')[0]
    }
    public static getFiltrosGeralAgenda(filtros: IFiltroOptions[]): any {
      try {
        let filtrosNomes = filtros.map((f: any) => {
          if (typeof f === 'string' || f instanceof String) {
            return `<span class="badge badge-info" style="margin-left: 5px;color: #ffffff;font-size: 10px;background-color: #9723f9;cursor: auto;border: none;font-weight: 700;">${f}</span>`
          } else {
            return `<span class="badge badge-info" style="margin-left: 5px;color: #ffffff;font-size: 10px;background-color: #9723f9;cursor: auto;border: none;font-weight: 700;">${f.nome}</span>`
          }
        }).join('')
        return filtrosNomes
      } catch (e) {
        return ""
      }

    }

    public static parseVersion(versao: string) {
      versao = versao.replace(".", "")
      versao = versao.replace(".", "")
      return parseInt(versao)
    }

    public static parsePositionFutBinToFilterFsw(position: any = null) {
      if (position && position.includes(",")) {
        switch (true) {
          case position.includes("CB"):
            return "defense"
          case position.includes("CAM"):
            return "midfield"
          case position.includes("ST"):
            return "attacker"
          default:
            return position;
        }
      } else {
        switch (position) {
          case "Defenders":
            return "defense"
          case "Midfielders":
            return "midfield"
          case "Attackers":
            return "attacker"
          default:
            return position;
        }
      }
    }

    public static getNomeAvatar(nomeCompleto: string) {
      var palavras = nomeCompleto.split(' ');
      var abreviacoes = palavras.map(function (palavra) {
        return palavra.charAt(0).toUpperCase();
      });
      return abreviacoes.join('');
    }
    public static obterCorRandomica() {
      var letras = '0123456789ABCDEF';
      var cor = '#';
      for (var i = 0; i < 6; i++) {
        cor += letras[Math.floor(Math.random() * 16)];
      }
      return cor;
    }

    public static getObjParametrosUrlLocation() {
      let queryString = window.location.search;
      let objUrlParams = new URLSearchParams(queryString);
      return objUrlParams;
    }

    private static getStepPorValorFiltro(t: any) {
      var r = this.pricesTiers.find(function (e: any) {
        return t >= e.min
      });
      return r.inc
    }

    public static getPrecoVariacaoMax(precoAtual: any, variacaoMaxAcima = 10) {
      let stepPreco = parseInt(this.getStepPorValorFiltro(precoAtual))
      precoAtual = parseInt(precoAtual)
      let variacaoMaxima = parseInt(precoAtual + (stepPreco * variacaoMaxAcima))
      return Util.tratarValorDeFiltro(variacaoMaxima)
    }

    public static getDadosTopSniperAnterior(dataTopSnipers: any = null) {
      if (typeof (Storage) !== "undefined") {
        var urlTopSniper = localStorage.getItem("urlTopSniper");
        var urlAtual = window.location.href;

        if (urlTopSniper === null) {
          // Se não houver uma URL armazenada, armazene a URL atual
          localStorage.setItem("urlTopSniper", urlAtual);
          Util.setArrayStorage("dataTopSnipers", dataTopSnipers);
          return null;
        } else if (urlTopSniper === urlAtual) {
          // A URL não foi alterada
          return Util.getArrayStorage("dataTopSnipers");
        } else {
          // A URL foi alterada, atualize a URL armazenada e retorne true
          localStorage.setItem("urlTopSniper", urlAtual);
          Util.setArrayStorage("dataTopSnipers", dataTopSnipers);
          return null;
        }
      } else {
        // O localStorage não é suportado no navegador
        console.log("O localStorage não é suportado neste navegador.");
        return null;
      }
    }

    // Função para inicializar o contador
    public static initializeCounter(key: string, valueInicialize: any = 0) {
      // Verifica se o contador já está armazenado no localStorage
      if (!localStorage.getItem(key)) {
        // Se não estiver, inicializa o contador com 0
        localStorage.setItem(key, valueInicialize);
      }
    }

    // Função para obter o valor atual do contador
    public static getCounterValue(key: string) {
      Util.initializeCounter(key); // Certifica-se de que o contador está inicializado
      return parseInt(localStorage.getItem(key)); // Retorna o valor do contador como um número inteiro
    }

    // Função para incrementar o contador
    public static incrementCounter(key: string) {
      Util.initializeCounter(key); // Certifica-se de que o contador está inicializado
      var currentValue: any = Util.getCounterValue(key); // Obtém o valor atual do contador
      currentValue++; // Incrementa o valor
      localStorage.setItem(key, currentValue); // Armazena o novo valor no localStorage
    }

    // Função para resetar o contador
    public static resetCounter(key: string, valueReset: any = 0) {
      localStorage.setItem(key, valueReset); // Define o valor do contador como 0
    }

    public static getLucroCarta(precoCompra: number, precoVenda: number = 0) {
      let impostoEa = precoVenda * 0.05;
      return (precoVenda - impostoEa) - precoCompra
    }

    public static async aguardarValorElemento(selector: string, timeout: number = 4000) {
      // Cria uma nova promise que resolve quando o valor não é mais vazio
      var obterValor = new Promise((resolve: any, reject: any) => {
        var interval = setInterval(() => {
          var valor = $(selector).val();
          if (valor) {
            clearInterval(interval);
            resolve(valor);
          }
        }, 100); // Verifica o valor a cada 100ms

        // Define um timeout para rejeitar a promise caso demore muito
        setTimeout(() => {
          clearInterval(interval);
          resolve(null);
        }, timeout);
      });

      // Aguarda a promise resolver ou rejeitar
      return await obterValor;
    }

    public static getIdServidorByUrl(url: any): string {
      if (!url || (!url.includes("/servidor/") && !url.includes("/cloud/"))) {
        return null;
      }

      let parts = url.split("/servidor/");

      if (parts.length <= 1) {
        parts = url.split("/cloud/");
      }

      if (parts.length > 1) {
        let idServidor = parts[1].split("/")[0];
        return idServidor
      } else {
        return null
      }
    }

    public static exibirLoadingFormModal(el: JQuery) {
      el.show();
    }

    public static ocultarLoadingFormModal(el: JQuery) {
      el.hide();
    }

    public static async getPublicIP(): Promise<string> {
      try {
        const response = await fetch(Util.URL_API_IPIFY);
        const data = await response.json();
        return data.ip;
      } catch (e) {
        console.error('Erro ao obter o endereço IP público:', e);
        return null;
      }
    }

    public static copyToClipboard(text: string, callbackSucesso: any = () => { console.log('Texto Copiado: ' + text); }) {
      if ((navigator as any)) {
        (navigator as any).clipboard.writeText(text).then(callbackSucesso).catch((err: any) => {
          console.error('Erro ao copiar texto: ', err);
        });
      } else {
        console.error('A API Clipboard não está disponível neste navegador.');
      }
    }

    public static getMensagemConferenciaFiltro(objMsgConferenciaFiltro: IConferenciaFiltro) {
      if (!objMsgConferenciaFiltro) {
        return `Certifique-se de que seus filtros estão configurados corretamente e não estão resultando em prejuízos.
        <br />Verifique se estão ativos e se há contas com saldo suficiente para operá-los. Caso deseje <b>ignorar ou ajustar a verificação do filtro</b>,
        <br />considere aumentar o valor do campo <b>"Conferir valor de compra"</b> no perfil da conta para um valor superior ao preço de compra do filtro atual.`;
      }
      // usando switch case para retornar a mensagem de acordo com codigo de erro
      switch (objMsgConferenciaFiltro.codigoErro) {
        case Util.ID_MENSAGEM_CONFERENCIA_FILTRO_MUITOS_ITENS:
          return `Para evitar prejuízos, a opção de segurança, <b>"Conferir valor de compra"</b> no perfil da conta, interrompeu o sniper,
          <br />foram encontrados resultados na busca após conferência. Ajuste o filtro, ou, caso queira ignorar ou ajustar essa conferência,
          <br />considere aumentar o valor do campo <b>"Conferir valor de compra"</b> no perfil da conta para um valor superior ao preço de compra do filtro atual.`;
        default:
          return `Certifique-se de que seus filtros estão configurados corretamente e não estão resultando em prejuízos.
          <br />Verifique se estão ativos e se há contas com saldo suficiente para operá-los.`;
      }

    }

    public static exibirNotificacaoPlanoExpirando() {
      if (!swal.isVisible() && $('.dropdown-menu-notificacao') && $('.dropdown-menu-notificacao').data('exibirNotificacao') == "1") {
        const lastClick = localStorage.getItem('lastNotificationPlanoExpirando');
        const now = new Date().getTime();
        // exemplo em 12 horas
        const tempoNovaNotificao = 12 * 60 * 60 * 1000;

        if (!lastClick || (now - parseInt(lastClick, 10)) > tempoNovaNotificao) {
          $('.dropdown-menu-notificacao').click();
          localStorage.setItem('lastNotificationPlanoExpirando', now.toString());
        }
      }
    }

    public static getMelhorPrecoFutbinEncontrado(prices: any) {
      const { LCPrice, LCPrice2, LCPrice3 } = prices;

      // Verifica se LCPrice2 ÃƒÂ© maior que LCPrice
      if (LCPrice2 > LCPrice) {
        return LCPrice2;
      }

      // Coloca os valores em um array
      const values = [LCPrice, LCPrice2, LCPrice3];

      // Conta a ocorrÃƒÂªncia de cada valor
      const counts = values.reduce((acc, value) => {
        acc[value] = (acc[value] || 0) + 1;
        return acc;
      }, {});

      // Encontra o valor que mais se repete
      let mostRepeated = values[0];
      let maxCount = 0;

      for (const value in counts) {
        if (counts[value] > maxCount) {
          maxCount = counts[value];
          mostRepeated = parseInt(value);
        }
      }

      // Se todos os valores forem iguais, retorna LCPrice2
      if (Object.keys(counts).length === 1) {
        return LCPrice2;
      }

      // Se houver um valor mais repetido, retorna-o, caso contrÃƒÂ¡rio, o primeiro valor acima de 0
      return mostRepeated > 0 ? mostRepeated : (values as any).find((val: any) => val > 0);

    }

    public static getStringPlataformaByIdPlataforma(idPlataforma: number) {
      return idPlataforma == 3 ? "PC" : 'PS';
    }

    public async getPrecoPlano(planoSelecionado: number, qtdContas: number, tipoPrecoPlano: string = '', planos: IPlano[], estrangeiro: boolean = false, callback = (valorPorConta: any) => { }): Promise<number> {

      const listaPlanos: IPlano[] = Array.isArray(planos) ? planos : [planos];

      const plano: IPlano | undefined = listaPlanos.find(p => p.id === planoSelecionado);
      //const plano: IPlano = planos.find(p => p.id === planoSelecionado);

      if (!plano) {
        throw new Error("Plano selecionado não encontrado.");
      }

      // Determina qual conjunto de valores usar (valor_padrao ou fidelidade)
      let tipoPreco = plano.dados[tipoPrecoPlano as keyof typeof plano.dados];
      if (!tipoPreco) {
        tipoPreco = ((Object as any).values(plano.dados) as TipoPreco[]).find((dado: TipoPreco) => dado.status);
      }

      if (!tipoPreco) {
        throw new Error("Nenhum tipo de preço válido encontrado.");
      }

      // Determina se deve usar valores do Brasil ou do Estrangeiro
      const valores = estrangeiro ? tipoPreco.valores.estrangeiro : tipoPreco.valores.brasil;

      // Obtém as chaves de valores e ordena para encontrar a faixa correta
      const qtdContasKeys = Object.keys(valores).map(Number).sort((a, b) => a - b);

      // Busca a faixa de quantidade de contas
      let valorPorConta: string | undefined = valores[qtdContas];
      if (!valorPorConta) {
        // Encontra a faixa anterior
        const faixaAnterior = qtdContasKeys.filter(key => key <= qtdContas).pop();

        // Encontra a próxima faixa
        const proximaFaixa = qtdContasKeys.find(key => key > qtdContas);

        // Determina a chave usada
        const chaveUsada = faixaAnterior !== undefined
          ? faixaAnterior // Prioriza a faixa anterior
          : (proximaFaixa !== undefined
            ? proximaFaixa // Usa a próxima faixa se a anterior não existir
            : qtdContasKeys[qtdContasKeys.length - 1]); // Usa a última faixa se nenhuma outra existir

        valorPorConta = valores[chaveUsada];
      }

      if (!valorPorConta) {
        return null
      }

      if (callback) {
        callback(valorPorConta);
      }

      // Retorna o preço total considerando a propriedade multiplicar
      return tipoPreco.multiplicar ? parseFloat(valorPorConta) * qtdContas : parseFloat(valorPorConta);
    }

    public static obterLinksFutbin(): { [key: number]: string } {
      const links: { [key: number]: string } = {};
      const container = document.getElementById('espacoCamposLinksDme');
      if (!container) return links;
      const inputs: any = container.querySelectorAll('input[id^="linkFutbin"]');
      inputs.forEach((input: any, idx: any) => {
        const value = (input as HTMLInputElement).value.trim();
        if (value) {
          links[idx + 1] = value;
        }
      });
      return links;
    }

    public static getPrecoPorLucroFixo(precoVenda: number, lucroFixo: number): number {
      const precoVendaLiquido = precoVenda * 0.95;
      let precoCompra = Util.tratarValorDeFiltro(Math.max(0, Math.floor(precoVendaLiquido - lucroFixo)));
      precoCompra = precoCompra && (precoCompra - precoVenda) < lucroFixo ? Util.decrementarValorDeFiltro(precoCompra) : precoCompra;
      return precoCompra < 200 ? 200 : precoCompra;
    }

    private static getLogJogadoresDescarte(dadosDescarte: { status: boolean, itens: IUTItemEntityResumo[], msg: string }): any {
      try {
        if (dadosDescarte && dadosDescarte.status) {
          if (Array.isArray(dadosDescarte.itens)) {
            return `<br />${dadosDescarte.itens
              .filter(obj => obj && obj.name)
              .map(obj => `<b>${obj.name}(${obj.rating})</b>`)
              .join(", ")}`;
          }

          return '';
        } else if (dadosDescarte && !dadosDescarte.status) {
          return `<br />Um erro ocorreu ao descartar(${dadosDescarte.msg})`;
        }
      } catch (e) {
        console.log("erro log getLogJogadoresDescarte", e)
        return ``;
      }
    }

    // Função para dividir um array em lotes
    public static chunkArray(array: any[], tamanho: number): any[][] {
      const resultado = [];
      for (let i = 0; i < array.length; i += tamanho) {
        resultado.push(array.slice(i, i + tamanho));
      }
      return resultado;
    }

    public static toggleDmes(element: JQuery) {
      const container = element.closest('.dmes-container');
      const expanded = container.querySelector('.dmes-expanded');

      if (expanded.style.display === 'none') {
        expanded.style.display = 'block';
        element.textContent = 'Menos-';
      } else {
        expanded.style.display = 'none';
        element.textContent = 'Mais+';
      }
    }
  }
}
